import React, {useEffect, useRef, useState} from "react";
import {t} from "i18next";
import {generateOtp, matchOtp} from "../service/userOtpApi";
import {toast} from "react-toastify";
import {addAccount, getMatchingProfiles, updateAccountById} from "../service/accountApi";
import {translateTextToDevnagri} from "../service/translateApi";
import {familyTreeNames} from "../data/FamilyTreeNames";
import {Modal} from "../components/Modal";
import {FindMyProfilePopup} from "../components/FindMyProfilePopup";
import {Link, useLocation} from "react-router-dom";
import {useAxiosPrivate} from "../hooks/useAxiosPrivate";
import {axiosPublic} from "../service/axios";
import {useAuth} from "../hooks/useAuth";
import {Check} from "lucide-react";
import {ChevronDownIcon} from "@heroicons/react/20/solid";
import {Transition, TransitionChild} from "@headlessui/react";
import {countryCodes} from "../data/CountryCode";


export const Register = () => {
	const location = useLocation();
	const showFindMyProfilePopupRafRef = useRef(null);
	const [showFindMyProfile, setShowFindMyProfile] = useState(false);
	const [popupVisible, setPopupVisible] = useState(false);

	const axiosPrivate = useAxiosPrivate();
	const pfpBgColors = ["bg-[#0F1F2E]", "bg-[#FF8C42]", "bg-[#FF3C38]", "bg-[#A23E48]"];

	const {setAccount, setAccessToken} = useAuth();

	const [totalSteps, setTotalSteps] = useState(4);
	const [currentStep, setCurrentStep] = useState(1);
	const [direction, setDirection] = useState('forward');

	const [profile, setProfile] = useState({
		email: '',

		firstName: '',
		middleName: '',
		lastName: '',

		firstNameDevanagariScript: '',
		middleNameDevanagariScript: '',
		lastNameDevanagariScript: '',

		dateOfBirth: '',

		familyTreeName: '',
		familyTreeNameDevanagariScript: '',

		gender: 'Male',

		phone: {
			charCode: 'IN',
			dialingCode: '+91',
			countryName: 'India',
			number: ''
		},

		maritalStatus: 'Single',
		sideOfFamily: '',

		imageUrlBg: pfpBgColors[Math.floor(Math.random() * pfpBgColors.length)]
	});

	const [areProfileDetailsValid, setAreProfileDetailsValid] = useState({
		1: true,
		2: true,
		3: true,
		4: true,
		5: true
	});

	const [isMemberOfJoglekarKul2010Granth, setIsMemberOfJoglekarKul2010Granth] = useState(false);

	const [isExactFamilyTreeNameKnown, setIsExactFamilyTreeNameKnown] = useState(false);
	const [showNavigateToSearchPageModal, setShowNavigateToSearchPageModal] = useState(false);

	const [isSeniorCitizen, setIsSeniorCitizen] = useState(false);

	const [filteredFamilyTreeNames, setFilteredFamilyTreeNames] = useState(familyTreeNames);
	const [isFamilyTreeNameDropdownOpen, setIsFamilyTreeNameDropdownOpen] = useState(false);
	const [isSelectingFamilyTreeName, setIsSelectingFamilyTreeName] = useState(false);

	const [isGenderDropdownOpen, setIsGenderDropdownOpen] = useState(false);
	const [isSelectingGender, setIsSelectingGender] = useState(false);

	const maritalStatusOptions = [
		{
			value: "Married",
			label: t("REGISTER_PAGE.MARITAL_STATUS.MARRIED")
		},
		{
			value: "Single",
			label: t("REGISTER_PAGE.MARITAL_STATUS.SINGLE")
		},
		{
			value: "Minor",
			label: t("REGISTER_PAGE.MARITAL_STATUS.MINOR")
		},
		{
			value: profile.gender === "Male" ? "Widower" : "Widowed",
			label: profile.gender === "Male"
				? t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER")
				: t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED")
		},
		{
			value: "Divorced",
			label: t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED")
		}
	];

	const [isMaritalStatusDropdownOpen, setIsMaritalStatusDropdownOpen] = useState(false);
	const [isSelectingMaritalStatus, setIsSelectingMaritalStatus] = useState(false);

	const [isJoglekarMaherVashin, setIsJoglekarMaheVashin] = useState(false);

	const [error, setError] = useState({});

	const [emailOtpData, setEmailOtpData] = useState({});
	const [emailOtp, setEmailOtp] = useState("");

	const [isSendEmailOtpButtonDisabled, setIsSendEmailOtpButtonDisabled] = useState(true);
	const [isSendEmailOtpSuccess, setIsSendEmailOtpSuccess] = useState(false);

	const [isVerifyEmailOtpButtonDisabled, setIsVerifyEmailOtpButtonDisabled] = useState(true);
	const [isVerifyEmailOtpSuccess, setIsVerifyEmailOtpSuccess] = useState(false);

	const [isCountryCodeDropdownOpen, setIsCountryCodeDropdownOpen] = useState(false);
	const [isSelectingCountryCode, setIsSelectingCountryCode] = useState(false);

	const [phoneNumberOtpData, setPhoneNumberOtpData] = useState({});
	const [phoneNumberOtp, setPhoneNumberOtp] = useState("");

	const [isSendPhoneNumberOtpButtonDisabled, setIsSendPhoneNumberOtpButtonDisabled] = useState(true);
	const [isSendPhoneNumberOtpSuccess, setIsSendPhoneNumberOtpSuccess] = useState(false);

	const [isVerifyPhoneNumberOtpButtonDisabled, setIsVerifyPhoneNumberOtpButtonDisabled] = useState(true);
	const [isVerifyPhoneNumberOtpSuccess, setIsVerifyPhoneNumberOtpSuccess] = useState(false);

	const [isRegisterButtonDisabled, setIsRegisterButtonDisabled] = useState(true);

	const [showMatchingProfilesModal, setShowMatchingProfilesModal] = useState(false);
	const [matchingProfiles, setMatchingProfiles] = useState([]);

	const translateToDevanagri = (e) => {
		if (e.target.value) {
			translateTextToDevnagri(e.target.value).then((res) => {
				console.log("(CreateProfile.jsx) Translation Response: ", res);
				setProfile(prev => ({
					...prev,
					[e.target.name + 'DevanagariScript']: res.result
				}));

				setError(prev => ({
					...prev,
					[e.target.name + 'DevanagariScript']: ""
				}));
			});
		}
	}

	const handleFamilyTreeNameSelect = (familyTreeName) => {
		setIsSelectingFamilyTreeName(false);
		setIsFamilyTreeNameDropdownOpen(false);
		setProfile(prev => ({
			...prev,
			familyTreeName
		}));
	}

	const handleGenderSelect = (gender = "") => {
		setIsSelectingGender(false);
		setIsGenderDropdownOpen(false);
		setProfile(prev => ({
			...prev,
			gender: gender
		}));
	}

	const maritalStatusLabel = (maritalStatus) => {
		switch (maritalStatus) {
			case 'Single':
				return t("REGISTER_PAGE.MARITAL_STATUS.SINGLE");
			case 'Married':
				return t("REGISTER_PAGE.MARITAL_STATUS.MARRIED");
			case 'Widower':
				return t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER");
			case 'Widowed':
				return t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED");
			case 'Divorced':
				return t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED");
			case 'Minor':
				return t("REGISTER_PAGE.MARITAL_STATUS.MINOR");
			default:
				return t("REGISTER_PAGE.MARITAL_STATUS.SINGLE");
		}
	}

	const handleMaritalStatusSelect = (maritalStatus) => {
		setIsSelectingMaritalStatus(false);
		setIsMaritalStatusDropdownOpen(false);
		setProfile(prev => ({
			...prev,
			maritalStatus: maritalStatus
		}));
	}

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		if (params.get("findMyProfile") === "true") {
			setShowFindMyProfile(true);
			cancelAnimationFrame(showFindMyProfilePopupRafRef.current);
			showFindMyProfilePopupRafRef.current = requestAnimationFrame(() => {
				showFindMyProfilePopupRafRef.current = requestAnimationFrame(() => {
					setPopupVisible(true);
				});
			});
		}

		// Cleanup in the same useEffect:
		return () => cancelAnimationFrame(showFindMyProfilePopupRafRef.current);
	}, []);

	const handleClosePopup = () => {
		setPopupVisible(false);
		// Clean URL without re-render or history entry
		window.history.replaceState({}, "", window.location.pathname);
		setTimeout(() => setShowFindMyProfile(false), 220);
	};

	useEffect(() => {
		if (profile.lastName.trim().toLowerCase() !== 'joglekar' && !isJoglekarMaherVashin) {
			setTotalSteps(4);
			setIsMemberOfJoglekarKul2010Granth(false);
			setProfile(prev => ({
				...prev,
				familyTreeName: '',
				familyTreeNameDevanagariScript: '',
				dateOfBirth: '',
				sideOfFamily: '',
			}));
		}

		if (!isMemberOfJoglekarKul2010Granth) {
			setTotalSteps(4);
			setProfile(prev => ({
				...prev,
				familyTreeName: '',
				familyTreeNameDevanagariScript: '',
				dateOfBirth: ''
			}));
		}

		if (isMemberOfJoglekarKul2010Granth && profile.lastName.trim().toLowerCase() === 'joglekar' && !isSeniorCitizen) {
			setTotalSteps(5);
		}

		if (
			isJoglekarMaherVashin ||
			(profile.lastName.trim().toLowerCase() === 'joglekar' && profile.gender === 'Female' &&
				(profile.maritalStatus === 'Single' || profile.maritalStatus === 'Minor'))
		) {
			setProfile(prev => ({
				...prev,
				sideOfFamily: 'MaherVashin'
			}));
		} else if (profile.gender === 'Male') {
			setProfile(prev => ({
				...prev,
				sideOfFamily: ''
			}));
		}
	}, [
		profile.gender, profile.maritalStatus, profile.lastName,
		isMemberOfJoglekarKul2010Granth, isJoglekarMaherVashin, isSeniorCitizen
	]);

	useEffect(() => {
		console.log("Date Of Birth: ", profile.dateOfBirth);
		if (profile.dateOfBirth) {
			let dateOfBirth;
			if (typeof profile.dateOfBirth === 'string') {
				// Try to parse the string into a Date object.
				// You might need to adjust the format based on how your date string is formatted.
				dateOfBirth = new Date(profile.dateOfBirth);
			} else if (profile.dateOfBirth instanceof Date) {
				// It's already a Date object
				dateOfBirth = profile.dateOfBirth;
			}

			// Ensure it's a valid Date object
			if (dateOfBirth && !isNaN(dateOfBirth)) {
				const today = new Date();
				const sixtyYearsAgo = new Date(today.getFullYear() - 60, today.getMonth(), today.getDate());

				// Adjust for the exact date of birth to be within the last 60 years
				const birthDateThisYear = new Date(today.getFullYear(), dateOfBirth.getMonth(), dateOfBirth.getDate());
				if (birthDateThisYear > today) {
					sixtyYearsAgo.setFullYear(sixtyYearsAgo.getFullYear() - 1);
				}

				if (dateOfBirth <= sixtyYearsAgo) {
					setIsSeniorCitizen(true);
					setTotalSteps(4);
				} else {
					setIsSeniorCitizen(false);
				}
			} else {
				setIsSeniorCitizen(false); // Or handle the invalid date case as needed
				console.error("Invalid date of birth:", profile.dateOfBirth);
			}
		} else {
			setIsSeniorCitizen(false); // No date of birth available
		}
	}, [profile.dateOfBirth]);

	const validateEmail = (email) => {
		return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
	}

	const validateEmailId = (e) => {
		if (e.target.value !== "") {
			if (!validateEmail(e.target.value)) {
				setError(prev => ({
					...prev,
					[e.target.name]: t("REGISTER_PAGE.EMAIL_INPUT.ERROR.INVALID_INPUT")
				}));
			} else {
				setIsSendEmailOtpButtonDisabled(false);

				if (Object.keys(error).includes(e.target.name)) {
					setError(prev => ({
						...prev,
						[e.target.name]: ""
					}));
				}
			}
		} else {
			setIsSendEmailOtpButtonDisabled(true);

			if (Object.keys(error).includes(e.target.name)) {
				setError(prev => ({
					...prev,
					[e.target.name]: ""
				}));
			}
		}
	}

	useEffect(() => {
		if (validateEmail(profile.email)) {
			setIsSendEmailOtpButtonDisabled(false);
		} else {
			setIsSendEmailOtpButtonDisabled(true);
		}
	}, [profile.email]);

	const handleCountryCodeSelect = (countryDetails) => {
		setIsSelectingCountryCode(false);
		setIsCountryCodeDropdownOpen(false);
		setProfile(prev => ({
			...prev,
			phone: {
				...prev.phone,
				charCode: countryDetails.countryCode,
				dialingCode: countryDetails.countryDialingCode,
				countryName: countryDetails.countryName
			}
		}));
	}

	const isNumberValid = (phone) => {
		let reg = /^\d+$/;
		return reg.test(phone);
	}

	const validatePhoneNumber = (e) => {
		if (e.target.value !== "") {
			if (!isNumberValid(e.target.value) || e.target.value.length < 10) {
				setError(prev => ({
					...prev,
					[e.target.name]: t("REGISTER_PAGE.PHONE_INPUT.ERROR.INVALID_INPUT")
				}));
			} else {
				setIsSendPhoneNumberOtpButtonDisabled(false);

				if (Object.keys(error).includes(e.target.name)) {
					setError(prev => ({
						...prev,
						[e.target.name]: ""
					}));
				}
			}
		} else {
			setIsSendPhoneNumberOtpButtonDisabled(true);

			if (Object.keys(error).includes(e.target.name)) {
				setError(prev => ({
					...prev,
					[e.target.name]: ""
				}));
			}
		}
	}

	useEffect(() => {
		if (!isNumberValid(profile.phone.number) || profile.phone.number.length < 10) {
			setIsSendPhoneNumberOtpButtonDisabled(true);
		} else {
			setIsSendPhoneNumberOtpButtonDisabled(false);
		}
	}, [profile.phone]);

	const handleFormData = (e) => {
		// console.log(e.target.name + ': ' + e.target.value);

		setProfile(prev => ({
			...prev,
			[e.target.name]: e.target.value
		}));

		if (Object.keys(error).includes(e.target.name) || e.target.value === "") {
			setError(prev => ({
				...prev,
				[e.target.name]: ""
			}));
		}
	}

	const sendOtpOnEmailButtonClick = () => {
		setIsSendEmailOtpButtonDisabled(true);
		generateOtp(axiosPublic, profile.email, "email", "register")
			.then((result) => {
				console.log("(Register.jsx) Send OTP Result: ", result);
				setEmailOtpData(result.data);
				setIsSendEmailOtpSuccess(true);
				if (Object.keys(error).includes("email")) {
					setError(prev => ({
						...prev,
						email: ""
					}));
				}
				toast.dismiss();
				toast.success(result.message, {
					// autoClose: 60000,
					closeOnClick: false
				});
			})
			.catch((error) => {
				console.log("(Register.jsx) Error while sending OTP: ", error);
				toast.dismiss();
				toast.error(error.data.message);
			})
			.finally(() => {
				setIsSendEmailOtpButtonDisabled(false);
			});
	}

	useEffect(() => {
		if (emailOtp.length === 6 && emailOtp) {
			setIsVerifyEmailOtpButtonDisabled(false);
		} else {
			setIsVerifyEmailOtpButtonDisabled(true);
		}
	}, [emailOtp]);

	const verifyEmailOtpButtonClick = () => {
		setIsVerifyEmailOtpButtonDisabled(true);
		if (emailOtpData && emailOtpData.userId && emailOtp) {
			matchOtp(axiosPublic, emailOtpData.userId, emailOtp, "register")
				.then((result) => {
					console.log("(Register.jsx) Match OTP Result: ", result);
					if (result.success) {
						setIsVerifyEmailOtpSuccess(true);
						toast.dismiss();
						toast.success(result.message);
					}
				})
				.catch((error) => {
					console.log("(Register.jsx) Error while matching OTP: ", error);
					toast.dismiss();
					toast.error(error.data.message);
				})
				.finally(() => {
					setIsVerifyEmailOtpButtonDisabled(false);
				});
		}
	}

	const sendOtpOnPhoneNumberButtonClick = () => {
		setIsSendPhoneNumberOtpButtonDisabled(true);
		generateOtp(axiosPublic, profile.phone, "phone", "register")
			.then((result) => {
				console.log("(Register.jsx) WhatsApp Number Send OTP Result: ", result);
				setPhoneNumberOtpData(result.data);
				setIsSendPhoneNumberOtpSuccess(true);
				if (Object.keys(error).includes("phone")) {
					setError(prev => ({
						...prev,
						phone: ""
					}));
				}
				toast.dismiss();
				toast.success(result.message, {
					autoClose: 60000,
					closeOnClick: false
				});
			})
			.catch((error) => {
				console.log("(Register.jsx) Error while sending WhatsApp Number OTP: ", error);
				toast.dismiss();
				toast.error(error.data.message);
			})
			.finally(() => {
				setIsSendPhoneNumberOtpButtonDisabled(false);
			});
	}

	useEffect(() => {
		if (phoneNumberOtp.length === 6 && phoneNumberOtp) {
			setIsVerifyPhoneNumberOtpButtonDisabled(false);
		} else {
			setIsVerifyPhoneNumberOtpButtonDisabled(true);
		}
	}, [phoneNumberOtp]);

	const verifyPhoneNumberOtpButtonClick = () => {
		setIsVerifyPhoneNumberOtpButtonDisabled(true);
		if (phoneNumberOtpData && phoneNumberOtpData.userId && phoneNumberOtp) {
			matchOtp(axiosPublic, phoneNumberOtpData.userId, phoneNumberOtp, "register")
				.then((result) => {
					console.log("(Register.jsx) WhatsApp Number Match OTP Result: ", result);
					if (result.success) {
						setIsVerifyPhoneNumberOtpSuccess(true);
						toast.dismiss();
						toast.success(result.message);
					}
				})
				.catch((error) => {
					console.log("(Register.jsx) Error while matching WhatsApp Number OTP: ", error);
					toast.dismiss();
					toast.error(error.data.message);
				})
				.finally(() => {
					setIsVerifyPhoneNumberOtpButtonDisabled(false);
				});
		}
	}

	useEffect(() => {
		if (profile.firstName && profile.middleName && profile.lastName) {
			setAreProfileDetailsValid(prev => ({
				...prev,
				1: false
			}));
		} else {
			setAreProfileDetailsValid(prev => ({
				...prev,
				1: true
			}));
		}
	}, [profile.firstName, profile.middleName, profile.lastName]);

	useEffect(() => {
		if (isMemberOfJoglekarKul2010Granth) {
			if (profile.familyTreeName && profile.dateOfBirth) {
				setAreProfileDetailsValid(prev => ({
					...prev,
					2: false
				}));
			} else {
				setAreProfileDetailsValid(prev => ({
					...prev,
					2: true
				}));
			}
		}
	}, [isMemberOfJoglekarKul2010Granth, profile.familyTreeName, profile.dateOfBirth]);

	useEffect(() => {
		if (profile.gender && profile.maritalStatus) {
			setAreProfileDetailsValid(prev => ({
				...prev,
				3: false
			}));
		} else {
			setAreProfileDetailsValid(prev => ({
				...prev,
				3: true
			}));
		}
	}, [profile.gender, profile.maritalStatus]);

	useEffect(() => {
		if (isVerifyEmailOtpSuccess || (isSeniorCitizen && isMemberOfJoglekarKul2010Granth)) {
			setAreProfileDetailsValid(prev => ({
				...prev,
				4: false
			}));
		} else {
			setAreProfileDetailsValid(prev => ({
				...prev,
				4: true
			}));
		}
	}, [isVerifyEmailOtpSuccess]);

	useEffect(() => {
		if (isVerifyPhoneNumberOtpSuccess && !isRegisterButtonDisabled) {
			setAreProfileDetailsValid(prev => ({
				...prev,
				5: false
			}));
		} else {
			setAreProfileDetailsValid(prev => ({
				...prev,
				5: true
			}));
		}
	}, [isVerifyPhoneNumberOtpSuccess, isRegisterButtonDisabled]);

	useEffect(() => {
		console.log("Profile Details Valid: ", areProfileDetailsValid);
	}, []);

	useEffect(() => {
		console.log("Register Button Disabled: ", isRegisterButtonDisabled);
	}, [isRegisterButtonDisabled]);

	useEffect(() => {
		if ((isVerifyEmailOtpSuccess || (isSeniorCitizen && isMemberOfJoglekarKul2010Granth)) && isVerifyPhoneNumberOtpSuccess) {
			setIsRegisterButtonDisabled(false);
		} else {
			setIsRegisterButtonDisabled(true);
		}
	}, [isSeniorCitizen, isVerifyEmailOtpSuccess, isVerifyPhoneNumberOtpSuccess]);

	useEffect(() => {
		if (
			profile.firstName !== '' && profile.middleName !== '' && profile.lastName !== '' &&
			(
				(isVerifyEmailOtpSuccess && isVerifyPhoneNumberOtpSuccess) ||
				(isSeniorCitizen && isVerifyPhoneNumberOtpSuccess)
			)
		) {
			if (isMemberOfJoglekarKul2010Granth && (profile.dateOfBirth === '' || profile.familyTreeName === '')) {
				setIsRegisterButtonDisabled(true);
			} else if (isMemberOfJoglekarKul2010Granth && (profile.dateOfBirth === '' || profile.familyTreeName === '')) {
				setIsRegisterButtonDisabled(false);
			} else if (!isMemberOfJoglekarKul2010Granth) {
				setIsRegisterButtonDisabled(false);
			}
		} else {
			setIsRegisterButtonDisabled(true);
		}
	}, [
		profile.firstName, profile.middleName, profile.lastName,
		isMemberOfJoglekarKul2010Granth, profile.dateOfBirth, profile.familyTreeName,
		isSeniorCitizen, isVerifyEmailOtpSuccess, isVerifyPhoneNumberOtpSuccess
	]);

	const validate = () => {
		let tempError = {...error}

		if (profile.firstName === '') {
			tempError['firstName'] = t("REGISTER_PAGE.NAME.ERROR.FIRST_NAME");
		}

		if (profile.middleName === '') {
			tempError['middleName'] = t("REGISTER_PAGE.NAME.ERROR.MIDDLE_NAME");
		}

		if (profile.lastName === '') {
			tempError['lastName'] = t("REGISTER_PAGE.NAME.ERROR.LAST_NAME");
		}

		if (isMemberOfJoglekarKul2010Granth) {
			if (profile.dateOfBirth === '') {
				tempError['dateOfBirth'] = t("REGISTER_PAGE.DOB.ERROR");
			}

			if (profile.familyTreeName === '') {
				tempError['familyTreeName'] = t("REGISTER_PAGE.FAMILY_TREE_NAME.ERROR");
			}
		}

		return tempError;
	}

	const addNewAccount = () => {
		setIsRegisterButtonDisabled(true);

		const trimmedProfile = {
			...profile,
			email: profile.email.trim(),

			firstName: profile.firstName.trim(),
			middleName: profile.middleName.trim(),
			lastName: profile.lastName.trim(),

			firstNameDevanagariScript: profile.firstNameDevanagariScript.trim(),
			middleNameDevanagariScript: profile.middleNameDevanagariScript.trim(),
			lastNameDevanagariScript: profile.lastNameDevanagariScript.trim(),

			dateOfBirth: profile.dateOfBirth.trim(),
			deceased: false,

			familyTreeName: profile.familyTreeName.trim(),
			familyTreeNameDevanagariScript: profile.familyTreeNameDevanagariScript.trim(),

			phone: {
				...profile.phone,
				number: profile.phone.number.trim()
			},

			sideOfFamily: profile.sideOfFamily.trim()
		};


		const accountData = {
			...trimmedProfile,
			imageUrl: trimmedProfile.firstName[0] + trimmedProfile.middleName[0],
			sideOfFamily: isJoglekarMaherVashin ? 'MaherVashin' : '',
			outsider: trimmedProfile.lastName.toLowerCase() !== 'joglekar' && !isJoglekarMaherVashin,
			registeredAt: new Date(),
		}

		console.log("(Register.jsx) New Account to be Added: ", accountData);

		if (isMemberOfJoglekarKul2010Granth) {
			getMatchingProfiles(accountData)
				.then((response) => {
					console.log("(Register.jsx) Get Matching Profiles Data: ", response);
					if (response.success) {
						setMatchingProfiles(response.data);
						if (response.data.length === 1) {
							console.log("Matching Profile Data: ", response.data);

							updateAccountById(axiosPrivate, response.data[0]._id, accountData)
								.then((response) => {
									console.log("(Register.jsx) Update Existing Matching Account By Id Response: ", response);

									if (response?.success) {
										toast.dismiss();
										setAccount(prevState => ({
											...prevState,
											...response.data.user
										}));
										setAccessToken(response.data.accessToken);
										toast.success(t("REGISTER_PAGE.REGISTRATION_SUCCESS.JOGLEKAR"));
									}
								})
								.catch((error) => {
									console.log("(Register.jsx) Update Existing Matching Account By Id Error: ", error);
								});
						} else {
							setShowMatchingProfilesModal(true);
						}
						setIsRegisterButtonDisabled(false);
					}
				})
				.catch((error) => {
					console.log("(Register.jsx) Error while getting Matching Profiles Data: ", error);
					setIsRegisterButtonDisabled(false);
				});
		} else {
			addAccount(axiosPrivate, accountData)
				.then((response) => {
					console.log("(Register.jsx) Account Added: ", response);
					if (response.success) {
						toast.dismiss();
						setAccount(prevState => ({
							...prevState,
							...response.data.user
						}));
						setAccessToken(response.data.accessToken);
						setIsRegisterButtonDisabled(false);

						if (response.data.user.lastName.toLowerCase() === 'joglekar') {
							toast.success(t("REGISTER_PAGE.REGISTRATION_SUCCESS.JOGLEKAR"));
						} else {
							toast.success(t("REGISTER_PAGE.REGISTRATION_SUCCESS.NON_JOGLEKAR"));
						}
					}
				})
				.catch((error) => {
					console.log("(Register.jsx) Error While Adding New Account: ", error);
					toast.dismiss();
					toast.error(error.data.message);
					setIsRegisterButtonDisabled(false);
				});
		}
	}

	// useEffect(() => {
	//     console.log("Updated Profile --> ", profile);
	// }, [profile]);
	//
	// useEffect(() => {
	//     console.log("(Register.jsx) (Changed) Family Tree Name: ", profile.familyTreeName);
	// }, [profile.familyTreeName]);

	useEffect(() => {
		const shouldLockScroll = isGenderDropdownOpen || isMaritalStatusDropdownOpen || isCountryCodeDropdownOpen || isFamilyTreeNameDropdownOpen;

		// Lock body scroll
		document.body.classList.toggle("overflow-y-hidden", shouldLockScroll);

		// Lock scroll on all scrollable containers
		const containers = document.querySelectorAll(".form-modal-body-container");
		containers.forEach((el) => {
			el.classList.toggle("!overflow-hidden", shouldLockScroll);
		});
	}, [
		isGenderDropdownOpen, isMaritalStatusDropdownOpen,
		isCountryCodeDropdownOpen, isFamilyTreeNameDropdownOpen
	]);

	// Navigate to the Next Step
	const nextStep = () => {
		let stepErrors = {};

		// Validate current step
		switch (currentStep) {
			case 1:
				// stepErrors = validateStep1();
				break;
			case 2:
				// stepErrors = validateStep2();
				break;
			case 3:
				// stepErrors = validateStep3();
				break;
			case 4:
				// stepErrors = validateStep4();
				break;
			case 5:
				// stepErrors = validateStep5();
				break;
			default:
				break;
		}

		if (isMemberOfJoglekarKul2010Granth && !isExactFamilyTreeNameKnown) {
			setShowNavigateToSearchPageModal(true);
			return;
		}

		// If on final step, submit the form
		if ((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? currentStep === totalSteps : currentStep === totalSteps + 1) {
			addNewAccount();
			return;
		}

		// Otherwise, go to the Next Step with Forward Animation
		setDirection('forward');
		setTimeout(() => {
			if (!isMemberOfJoglekarKul2010Granth && currentStep === 1) {
				setCurrentStep(currentStep + 2);
			} else if (isSeniorCitizen && currentStep === 3) {
				setCurrentStep(currentStep + 2);
			} else {
				setCurrentStep(currentStep + 1);
			}
		}, 50);
	};

	// Navigate to the Previous Step with Backward Animation
	const prevStep = () => {
		if (currentStep > 1) {
			setDirection('backward');
			setTimeout(() => {
				if (!isMemberOfJoglekarKul2010Granth && currentStep === 3) {
					setCurrentStep(currentStep - 2);
				} else if (isSeniorCitizen && currentStep === 5) {
					setCurrentStep(currentStep - 2);
				} else {
					setCurrentStep(currentStep - 1);
				}
			}, 50);
		}
	};

	const getAdjustedStepNumber = (index) => {
		if (!isMemberOfJoglekarKul2010Granth && index >= 1) {
			return index + 2; // Skip Step 2 (B'Date and Family Tree Name) when not needed
		} else if (isSeniorCitizen && index >= 3) {
			return index + 2; // Skip Step 4 (Senior Citizen) when not needed
		}
		return index + 1;
	};

	// Progress indicator
	const renderProgressBar = () => {
		return (
			<div>
				<div className="flex items-center justify-between">
					{[...Array(totalSteps)].map((_, index) => (
						<div
							key={index}
							className={`${index < totalSteps - 1 && 'w-full flex-1'} flex items-center`}
						>
							{/* Step circle */}
							<div
								className={`portrait:w-[2rem] landscape:w-[2.75rem] aspect-square
                                    rounded-full flex items-center justify-center font-custom-medium
                                    transition-colors duration-500 
                                    ${((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? index + 1 : getAdjustedStepNumber(index)) === currentStep
									? 'bg-[#D26A53] text-white ring-2 ring-offset-2 ring-[#5F0F40]'
									: ((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? index + 1 : getAdjustedStepNumber(index)) < currentStep
										? 'bg-green-500 text-white'
										: 'bg-gray-200 text-gray-600'
								}`}
							>
								{
									((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? index + 1 : getAdjustedStepNumber(index)) < currentStep
										? <Check size={20}/>
										: index + 1
								}
							</div>

							{/* Connector line */}
							{index < totalSteps - 1 && (
								<div
									className={`h-1 w-full flex-1 mx-2 rounded-full 
                                    transition-colors duration-500 
                                    ${((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? index + 1 : getAdjustedStepNumber(index)) < currentStep
										? 'bg-green-500'
										: ((isMemberOfJoglekarKul2010Granth && !isSeniorCitizen) ? index + 1 : getAdjustedStepNumber(index)) === currentStep
											? 'bg-[#D26A53]'
											: 'bg-gray-200'
									}`}
								/>
							)}
						</div>
					))}
				</div>

				{/*/!* Step labels *!/*/}
				{/*<div className="flex justify-between mt-2 px-1">*/}
				{/*    {[...Array(totalSteps)].map((_, index) => (*/}
				{/*        <div key={index} className="w-10 text-center text-sm font-medium text-gray-600">*/}
				{/*            {index === 0 && 'Personal'}*/}
				{/*            {index === 1 && 'Account'}*/}
				{/*            {index === 2 && 'Contact'}*/}
				{/*            {index === 3 && 'Address'}*/}
				{/*        </div>*/}
				{/*    ))}*/}
				{/*</div>*/}
			</div>
		);
	}

	// Rendering Registration Form Steps
	const renderRegistrationSteps = () => {
		const animationClass = direction === 'forward'
			? 'translate-x-full opacity-0 animate-slideInRight'
			: 'translate-x-full opacity-0 animate-slideInLeft';

		switch (currentStep) {
			case 1:
				return (
					// Full Name | Joglekar Kul 2010 Granth Member
					<fieldset
						key="step1"
						className={`w-full flex flex-col
                            multiple-input-fields-gap ${animationClass}`}
					>
						{/* Full Name */}
						<div
							className="!flex-1 !w-full custom-input-container"
						>
							{/* Label */}
							<label htmlFor="firstName">
								{t("REGISTER_PAGE.NAME.LABEL.BASE")}
							</label>

							{/* Full Name - Input Fields */}
							<div className="custom-input-multiple-fields-container">
								{/* First Name */}
								{/*<div className="flex-1 flex flex-col gap-1">*/}
								<input
									id="firstName"
									className={"custom-input w-full"}
									name='firstName'
									placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.FIRST_NAME")}
									value={profile.firstName}
									onChange={handleFormData}
									onFocus={() => {
										setError(prev => ({
											...prev,
											firstName: "",
											middleName: "",
											lastName: ""
										}));
									}}
									onBlur={translateToDevanagri}
								/>
								{/*</div>*/}

								{/* Middle Name */}
								{/*<div className="flex-1 flex flex-col gap-1">*/}
								<input
									id="middleName"
									className={"custom-input w-full"}
									name='middleName'
									placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.MIDDLE_NAME")}
									value={profile.middleName}
									onChange={handleFormData}
									onFocus={() => {
										setError(prev => ({
											...prev,
											firstName: "",
											middleName: "",
											lastName: ""
										}));
									}}
									onBlur={translateToDevanagri}
								/>
								{/*</div>*/}

								{/* Last Name */}
								{/*<div className="flex-1 flex flex-col gap-1">*/}
								<input
									className={"custom-input w-full"}
									id="lastName"
									name='lastName'
									placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.LAST_NAME")}
									value={profile.lastName}
									onChange={handleFormData}
									onFocus={() => {
										setError(prev => ({
											...prev,
											firstName: "",
											middleName: "",
											lastName: ""
										}));
									}}
									onBlur={translateToDevanagri}
								/>
								{/*</div>*/}
							</div>

							{/*/!* Error Container *!/*/}
							{/*{*/}
							{/*    (error['firstName'] !== '' || error['middleName'] !== '' || error['lastName'] !== '') && (*/}
							{/*        <div*/}
							{/*            className="custom-input-multiple-fields-container portrait:hidden"*/}
							{/*        >*/}
							{/*            <p*/}
							{/*                className="flex-1 text-red-600 font-custom-regular*/}
							{/*                    portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                    landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                    landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                id="error"*/}
							{/*            >*/}
							{/*                {error['firstName'] ? error['firstName'] : ''}*/}
							{/*            </p>*/}

							{/*            <p*/}
							{/*                className="flex-1 text-red-600 font-custom-regular*/}
							{/*                    portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                    landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                    landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                id="error"*/}
							{/*            >*/}
							{/*                {error['middleName'] ? error['middleName'] : ''}*/}
							{/*            </p>*/}

							{/*            <p*/}
							{/*                className="flex-1 text-red-600 font-custom-regular*/}
							{/*                    portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                    landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                    landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                id="error"*/}
							{/*            >*/}
							{/*                {error['lastName'] ? error['lastName'] : ''}*/}
							{/*            </p>*/}
							{/*        </div>*/}
							{/*    )*/}
							{/*}*/}
						</div>

						{/* Are you a Member of Joglekarkul 2010 Granth */}
						{
							(profile.lastName.trim().toLowerCase() === 'joglekar' || isJoglekarMaherVashin) && (
								<div
									className={`flex-1 flex flex-col items-start
                                        portrait:gap-y-[0.5rem] portrait:md:gap-y-[0.25rem]
                                        portrait:jk:gap-y-[0.45rem] portrait:lg:gap-y-[0.75rem]
                                        landscape:gap-y-[0.1rem] landscape:md:gap-y-[0.15rem]
                                        landscape:jk:gap-y-[0.2rem] landscape:lg:gap-y-[0.3rem]`}
								>
									{/* Label */}
									<div className={`w-full flex-1 flex flex-col items-start`}>
										<p
											className={`w-full font-custom-medium leading-6 text-gray-600
                                                portrait:text-[0.85rem] portrait:md:text-[0.8rem]
                                                portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                                landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                                landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]`}
										>
											{t("REGISTER_PAGE.MEMBER_OF_JOGLEKARKUL_2010_GRANTH.LABEL")}
										</p>
									</div>

									{/* Yes | No Radio Buttons */}
									<div
										className={`custom-input-multiple-fields-container 
                                            w-full flex-1`}
									>
										{/* Yes */}
										<label className={`custom-input-checkbox`}>
											<div
												className={`${isMemberOfJoglekarKul2010Granth ?
													'bg-[#FF6600] border-orange-300'
													: 'bg-white border-[#CBCBCB]'}`}
											>
												<img
													src={"/assets/tick-icon-light.svg"}
													alt={"Select"}
													title={"Select"}
												/>
												<input
													type="checkbox"
													className="absolute hidden"
													checked={isMemberOfJoglekarKul2010Granth}
													onChange={() => setIsMemberOfJoglekarKul2010Granth(true)}
												/>
											</div>
											<span
												className={`flex-1 flex items-center
                                                    portrait:gap-[0.5rem] portrait:md:gap-[0.25rem] 
                                                    portrait:jk:gap-[0.45rem] portrait:lg:gap-[0.75rem]
                                                    landscape:gap-[0.1rem] landscape:md:gap-[0.15rem]
                                                    landscape:jk:gap-[0.2rem] landscape:lg:gap-[0.3rem]`}
											>
                                                <p
	                                                className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                        landscape:lg:text-[1rem] leading-tight 
                                                        font-custom-regular text-gray-900`}
                                                >
                                                    {t("REGISTER_PAGE.MEMBER_OF_JOGLEKARKUL_2010_GRANTH.OPTIONS.YES")}
                                                </p>
                                            </span>
										</label>

										{/* No */}
										<label className="custom-input-checkbox">
											<div
												className={`${!isMemberOfJoglekarKul2010Granth
													? 'bg-[#FF6600] border-orange-300'
													: 'bg-white border-[#CBCBCB]'}`}
											>
												<img
													src={"/assets/tick-icon-light.svg"}
													alt={"Select"}
													title={"Select"}
												/>
												<input
													type="checkbox"
													checked={!isMemberOfJoglekarKul2010Granth}
													className="absolute hidden"
													onChange={() => setIsMemberOfJoglekarKul2010Granth(false)}
												/>
											</div>
											<p
												className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                    landscape:lg:text-[1rem] leading-tight 
                                                    font-custom-regular text-gray-900`}
											>
												{t("REGISTER_PAGE.MEMBER_OF_JOGLEKARKUL_2010_GRANTH.OPTIONS.NO")}
											</p>
										</label>
									</div>
								</div>
							)
						}

						{/* Do you know your Exact Family Tree Name? */}
						{
							isMemberOfJoglekarKul2010Granth && (
								<div
									className={`flex-1 flex flex-col items-start
                                        portrait:gap-y-[0.5rem] portrait:md:gap-y-[0.25rem]
                                        portrait:jk:gap-y-[0.45rem] portrait:lg:gap-y-[0.75rem]
                                        landscape:gap-y-[0.1rem] landscape:md:gap-y-[0.15rem]
                                        landscape:jk:gap-y-[0.2rem] landscape:lg:gap-y-[0.3rem]`}
								>
									{/* Label */}
									<div className={`w-full flex-1 flex flex-col items-start`}>
										<p
											className={`w-full font-custom-medium leading-6 text-gray-600
                                                portrait:text-[0.85rem] portrait:md:text-[0.8rem]
                                                portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                                landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                                landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]`}
										>
											{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.LABEL")}
										</p>
									</div>

									{/* Yes | No Radio Buttons */}
									<div
										className={`custom-input-multiple-fields-container 
                                            w-full flex-1`}
									>
										{/* Yes */}
										<label className={`custom-input-checkbox`}>
											<div
												className={`${isExactFamilyTreeNameKnown ?
													'bg-[#FF6600] border-orange-300'
													: 'bg-white border-[#CBCBCB]'}`}
											>
												<img
													src={"/assets/tick-icon-light.svg"}
													alt={"Select"}
													title={"Select"}
												/>
												<input
													type="checkbox"
													className="absolute hidden"
													checked={isExactFamilyTreeNameKnown}
													onChange={() => setIsExactFamilyTreeNameKnown(true)}
												/>
											</div>
											<span
												className={`flex-1 flex items-center
                                                    portrait:gap-[0.5rem] portrait:md:gap-[0.25rem] 
                                                    portrait:jk:gap-[0.45rem] portrait:lg:gap-[0.75rem]
                                                    landscape:gap-[0.1rem] landscape:md:gap-[0.15rem]
                                                    landscape:jk:gap-[0.2rem] landscape:lg:gap-[0.3rem]`}
											>
                                                <p
	                                                className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                        landscape:lg:text-[1rem] leading-tight 
                                                        font-custom-regular text-gray-900`}
                                                >
                                                    {t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.OPTIONS.YES")}
                                                </p>
                                            </span>
										</label>

										{/* No */}
										<label className="custom-input-checkbox">
											<div
												className={`${!isExactFamilyTreeNameKnown
													? 'bg-[#FF6600] border-orange-300'
													: 'bg-white border-[#CBCBCB]'}`}
											>
												<img
													src={"/assets/tick-icon-light.svg"}
													alt={"Select"}
													title={"Select"}
												/>
												<input
													type="checkbox"
													checked={!isExactFamilyTreeNameKnown}
													className="absolute hidden"
													onChange={() => setIsExactFamilyTreeNameKnown(false)}
												/>
											</div>
											<p
												className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                    landscape:lg:text-[1rem] leading-tight 
                                                    font-custom-regular text-gray-900`}
											>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.OPTIONS.NO")}
											</p>
										</label>
									</div>
								</div>
							)
						}
					</fieldset>
				);

			case 2:
				return (
					// Date of Birth | Family Tree Name
					<fieldset
						key="step2"
						className={`w-full ${animationClass}`}
					>
						{
							isMemberOfJoglekarKul2010Granth && (
								<div className="custom-input-multiple-fields-container">
									{/* Date of Birth */}
									<div className="custom-input-container">
										<label>
											{t("REGISTER_PAGE.DOB.LABEL")}
										</label>
										<div className="flex flex-col w-full">
											<input
												type="date"
												name='dateOfBirth'
												required
												value={profile.dateOfBirth}
												onChange={handleFormData}
												className="custom-input"
											/>
											{/*{*/}
											{/*    error['dateOfBirth'] &&*/}
											{/*    <p*/}
											{/*        className="custom-input-error-message"*/}
											{/*        id="error"*/}
											{/*    >*/}
											{/*        {error['dateOfBirth']}*/}
											{/*    </p>*/}
											{/*}*/}
										</div>
									</div>

									{/* Family Tree Name */}
									<div className="custom-input-container">
										<label>
											{t("REGISTER_PAGE.FAMILY_TREE_NAME.LABEL")}
										</label>

										<div className="h-full w-full flex flex-col">
											{/* Family Tree Name Input */}
											<div
												className={`custom-input-dropdown-button
                                                ${isFamilyTreeNameDropdownOpen && 'ring-4 ring-offset-1 ring-[#5F0F40]'}`}
											>
												<input
													id="familyTreeName"
													name="familyTreeName"
													value={profile.familyTreeName}
													onBlur={(e) => {
														console.log("Family Tree Name Input Blur: ", isSelectingFamilyTreeName);
														if (!isSelectingFamilyTreeName) {
															setIsFamilyTreeNameDropdownOpen(false);
														}
														translateToDevanagri(e);
													}}
													onClick={() => setIsFamilyTreeNameDropdownOpen(true)}
													onKeyUp={(e) => {
														if (e.key === "Escape") {
															setIsFamilyTreeNameDropdownOpen(false);
														}
													}}
													onFocus={(e) => {
														if (e.target.value === "") {
															setFilteredFamilyTreeNames(familyTreeNames);
														} else {
															console.log("Family Tree Name Input Value: ", e.target.value);
															setFilteredFamilyTreeNames(
																familyTreeNames
																	.filter((familyTreeName) => {
																		return familyTreeName.toLowerCase().includes(e.target.value.toLowerCase());
																	})
															);
														}
													}}
													onChange={(e) => {
														if (e.target.value === "") {
															setFilteredFamilyTreeNames(familyTreeNames);
														} else {
															console.log("Family Tree Name Input Value: ", e.target.value);
															setFilteredFamilyTreeNames(
																familyTreeNames
																	.filter((familyTreeName) => {
																		return familyTreeName.toLowerCase().includes(e.target.value.toLowerCase());
																	})
															);
														}

														setProfile(prev => ({
															...prev,
															[e.target.name]: e.target.value
														}));

														setError(prev => ({
															...prev,
															[e.target.name]: ""
														}));
													}}
												/>

												<ChevronDownIcon
													className={`${isFamilyTreeNameDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
													aria-hidden="true"
													stroke="#292D32"
													strokeWidth={"0.1vh"}
													onClick={() => setIsFamilyTreeNameDropdownOpen(!isFamilyTreeNameDropdownOpen)}
												/>
											</div>

											{/* Family Tree Name Dropdown */}
											<div className={"relative"}>
												<Transition show={isFamilyTreeNameDropdownOpen}>
													<div
														className={`bg-white absolute left-0 right-0 z-[100]
                                                            origin-top-right rounded-md shadow-2xl mt-[0.5vh]
                                                            landscape:mx-[0.75rem] landscape:jk:mx-[0.9rem] landscape:lg:mx-[1.15rem]
                                                            border border-gray-700
                                                            data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                            data-[enter]:duration-100 data-[enter]:ease-out 
                                                            data-[leave]:duration-75 data-[leave]:ease-in`}
													>
														<div
															className={`w-full flex-1 overflow-hidden 
                                                                relative rounded-md`}
														>
															<div
																className="flex-1 flex flex-col max-h-[30vh] w-full overflow-y-scroll"
															>
																{
																	filteredFamilyTreeNames.length > 0
																		? filteredFamilyTreeNames.map((familyTreeName, index) => (
																			<button
																				key={index}
																				className={`custom-input-dropdown-list-button`}
																				onMouseDown={() => setIsSelectingFamilyTreeName(true)}
																				onClick={() => handleFamilyTreeNameSelect(familyTreeName)}
																			>
																				<p className={`text-nowrap overflow-x-scroll no-scrollbar`}>
																					{familyTreeName}
																				</p>
																			</button>
																		)) : (
																			<button
																				className={`custom-input-dropdown-list-button`}
																				onClick={() => setIsFamilyTreeNameDropdownOpen(false)}
																			>
																				<p className={`text-nowrap overflow-x-scroll no-scrollbar`}>
																					{profile.familyTreeName}
																				</p>
																			</button>
																		)
																}
															</div>
														</div>
													</div>
												</Transition>
											</div>
										</div>
									</div>
								</div>
							)
						}
					</fieldset>
				);

			case 3:
				return (
					// Gender | Marital Status
					<fieldset key="step3" className={`w-full ${animationClass}`}>
						<div className="custom-input-multiple-fields-container w-full">
							{/* Gender */}
							<div className="custom-input-container">
								{/* Gender Label */}
								<label htmlFor="gender">
									{t("REGISTER_PAGE.GENDER.LABEL")}
								</label>

								{/* Gender Button | Dropdown */}
								<div className="h-full w-full flex flex-col">
									<button
										onBlur={() => {
											if (!isSelectingGender) {
												setIsGenderDropdownOpen(false);
											}
										}}
										className={`custom-input-dropdown-button
                                    ${isGenderDropdownOpen ? 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]' : ''}`}
										onClick={() => setIsGenderDropdownOpen(!isGenderDropdownOpen)}
									>
										<div>
											<p>
												{
													profile.gender === "Male"
														? t("REGISTER_PAGE.GENDER.MALE")
														: t("REGISTER_PAGE.GENDER.FEMALE")
												}
											</p>
											<img
												src={profile.gender === "Male" ? "assets/male-gender-icon.png" : "assets/female-gender-icon.png"}
												alt={profile.gender === "Male" ? "Male" : "Female"}
											/>
										</div>
										<ChevronDownIcon
											className={`${isGenderDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
											aria-hidden="true"
											stroke="#292D32"
											strokeWidth={"0.1vh"}
										/>
									</button>

									{/* Gender Dropdown */}
									<div className={"relative mt-[0.5vh]"}>
										<Transition show={isGenderDropdownOpen}>
											<div
												className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                origin-top-right rounded-md shadow-2xl 
                                                border border-gray-700 overflow-y-scroll
                                                data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                data-[enter]:duration-100 data-[enter]:ease-out 
                                                data-[leave]:duration-75 data-[leave]:ease-in`}
											>
												<button
													className="custom-input-dropdown-list-button"
													onClick={() => handleGenderSelect("Male")}
													onMouseDown={() => setIsSelectingGender(true)}
												>
													<p>
														{t("REGISTER_PAGE.GENDER.MALE")}
													</p>
													<img
														src={"assets/male-gender-icon.png"}
														alt={"Male"}
													/>
												</button>
												<button
													className="custom-input-dropdown-list-button"
													onClick={() => handleGenderSelect("Female")}
													onMouseDown={() => setIsSelectingGender(true)}
												>
													<p>
														{t("REGISTER_PAGE.GENDER.FEMALE")}
													</p>
													<img
														src={"assets/female-gender-icon.png"}
														alt={"Female"}
													/>
												</button>
											</div>
										</Transition>
									</div>
								</div>
							</div>

							{/* Marital Status */}
							<div className="custom-input-container">
								{/* Marital Status Label */}
								<label htmlFor="maritalStatus">
									<img
										src={"assets/marriage-icon.png"}
										alt={"Marriage"}
										title={"Marriage"}
									/>
									{t("REGISTER_PAGE.MARITAL_STATUS.LABEL")}
								</label>

								{/* Marital Status Button | Dropdown */}
								<div className="h-full w-full flex flex-col">
									<button
										onBlur={() => {
											if (!isSelectingMaritalStatus) {
												setIsMaritalStatusDropdownOpen(false);
											}
										}}
										className={`custom-input-dropdown-button
                                        ${isMaritalStatusDropdownOpen && 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]'}`}
										onClick={() => setIsMaritalStatusDropdownOpen(!isMaritalStatusDropdownOpen)}
									>
										<p>
											{maritalStatusLabel(profile.maritalStatus)}
										</p>
										<ChevronDownIcon
											className={`${isMaritalStatusDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
											aria-hidden="true"
											stroke="#292D32"
											strokeWidth={"0.1vh"}
										/>
									</button>

									{/* Marital Status Dropdown */}
									<div className={"relative mt-[0.5vh]"}>
										<Transition show={isMaritalStatusDropdownOpen}>
											<div
												className={`bg-white absolute left-0 right-0 z-[100] 
                                                max-h-[5rem] origin-top-right rounded-md shadow-2xl 
                                                border border-gray-700 overflow-y-scroll
                                                data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                data-[enter]:duration-100 data-[enter]:ease-out 
                                                data-[leave]:duration-75 data-[leave]:ease-in`}
											>
												{
													maritalStatusOptions.map((option, index) => (
														<button
															key={index}
															className="custom-input-dropdown-list-button"
															onClick={() => handleMaritalStatusSelect(option.value)}
															onMouseDown={() => setIsSelectingMaritalStatus(true)}
														>
															<p>
																{option.label}
															</p>
														</button>
													))
												}
											</div>
										</Transition>
									</div>
								</div>
							</div>
						</div>

						{/* Are you MaherVashin */}
						{
							profile.lastName.trim().toLowerCase() !== 'joglekar' && profile.gender === 'Female' && (
								profile.maritalStatus === 'Married' || profile.maritalStatus === 'Divorced'
								|| profile.maritalStatus === 'Widowed'
							) && (
								<label className="custom-input-label-checkbox">
									<input
										type="checkbox"
										name='isJoglekarMaherVashin'
										checked={isJoglekarMaherVashin}
										onChange={() => setIsJoglekarMaheVashin(!isJoglekarMaherVashin)}
									/>
									<p>
										{t("REGISTER_PAGE.IS_MAHER_VASHIN")}
									</p>
								</label>
							)
						}
					</fieldset>
				);

			case 4:
				return (
					// Email ID - OTP Verification
					<fieldset
						key="step4"
						className={`w-full flex flex-col
                            multiple-input-fields-gap ${animationClass}`}
					>
						{/* Email Input | Send OTP Button */}
						{
							!isSeniorCitizen && (
								<div className={`flex flex-col multiple-input-fields-gap`}>
									{/* Email Input  */}
									<div className="custom-input-container">
										<label htmlFor="email">
											{t("REGISTER_PAGE.EMAIL_INPUT.LABEL")}
										</label>

										<input
											disabled={isVerifyEmailOtpSuccess}
											type="email"
											name="email"
											value={profile.email}
											onChange={handleFormData}
											id="email"
											className={`custom-input`}
											onBlur={validateEmailId}
										/>

										{error['email'] && (
											<p className="custom-input-error-message" id="email-error">
												{error['email']}
											</p>
										)}
									</div>

									{/* Email - Send OTP */}
									<button
										disabled={isSendEmailOtpButtonDisabled || isVerifyEmailOtpSuccess}
										onClick={sendOtpOnEmailButtonClick}
										className={`${!isSendEmailOtpButtonDisabled && 'arrow-button'}
                                            w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                            landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                            
                                            portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                            landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                            
                                            hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                            disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                            disabled:ring-0 disabled:ring-offset-0
                                            transition-all duration-300 ease-in-out`}
									>
										<p
											className="line-clamp-1 text-white leading-tight font-custom-medium
                                                portrait:text-[1rem] portrait:md:text-[1rem]
                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                landscape:lg:text-[1rem]"
										>
											{
												isVerifyEmailOtpSuccess
													? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")
													: t("REGISTER_PAGE.OTP_BUTTON.SEND")
											}
										</p>
										{
											!isVerifyEmailOtpSuccess && (
												<svg
													viewBox="0 0 6 6"
													fill="none"
													id={"arrow-icon"}
													className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                                        portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                                        portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                                        landscape:h-[0.65rem] landscape:w-[0.65rem]
                                                        landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                                        landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M3 1L5 3L3 5"
														id={"arrow-icon-tip"}
														stroke="white"
														strokeLinecap="square"
													/>
													<path
														d="M1 3L4 3"
														id={"arrow-icon-line"}
														stroke="white"
														strokeLinecap="square"
													/>
												</svg>
											)
										}
									</button>
								</div>
							)
						}

						{/* Email - OTP Input | Verify OTP */}
						{isSendEmailOtpSuccess && (!isVerifyEmailOtpSuccess) && (
							<div className={`flex flex-col multiple-input-fields-gap`}>
								{/* Email - OTP Input */}
								<div className="custom-input-container">
									<label
										htmlFor="emailOtp"
									>
										{t("REGISTER_PAGE.OTP_BUTTON.ENTER")}
									</label>
									<div className={`flex portrait:gap-2 portrait:jk:gap-4 landscape:gap-2`}>
										<input
											type="text"
											name="emailOtp"
											value={emailOtp}
											onChange={(e) => setEmailOtp(e.target.value)}
											id="otp"
											className={`custom-input`}
										/>
									</div>
								</div>

								{/* Email - Verify OTP */}
								<button
									disabled={isVerifyEmailOtpButtonDisabled}
									onClick={verifyEmailOtpButtonClick}
									className={`${isVerifyEmailOtpButtonDisabled ? '' : 'arrow-button'} 
                                        w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                        landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                        
                                        portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                        landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                        
                                        hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                        disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                        disabled:ring-0 disabled:ring-offset-0
                                        transition-all duration-300 ease-in-out`}
								>
									<p
										className="line-clamp-1 text-white leading-tight font-custom-medium
                                            portrait:text-[1rem] portrait:md:text-[1rem]
                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                            landscape:lg:text-[1rem]"
									>
										{t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}
									</p>
									<svg
										viewBox="0 0 6 6"
										fill="none"
										id={"arrow-icon"}
										className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                            portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                            portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                            landscape:h-[0.65rem] landscape:w-[0.65rem]
                                            landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                            landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M3 1L5 3L3 5"
											id={"arrow-icon-tip"}
											stroke="white"
											strokeLinecap="square"
										/>
										<path
											d="M1 3L4 3"
											id={"arrow-icon-line"}
											stroke="white"
											strokeLinecap="square"
										/>
									</svg>
								</button>
							</div>
						)}
					</fieldset>
				);

			case 5:
				return (
					// WhatsApp Number - OTP Verification
					<fieldset
						key="step5"
						className={`w-full flex flex-col
                            multiple-input-fields-gap ${animationClass}`}
					>
						{/* WhatsApp Number */}
						<div className="custom-phone-number-input">
							<label htmlFor="phone">
								{t("REGISTER_PAGE.PHONE_INPUT.LABEL")}
							</label>
							<div
								className="flex-1 flex flex-col
                                    portrait:gap-2 portrait:jk:gap-4 landscape:gap-2"
							>
								{/* Country Code | WhatsApp Number Input */}
								<div className="custom-phone-number-input-container">
									{/* Country Code Button */}
									<button
										disabled={isVerifyPhoneNumberOtpSuccess}
										onBlur={() => {
											if (!isSelectingCountryCode) {
												setIsCountryCodeDropdownOpen(false);
											}
										}}
										onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
									>
										<img
											src={`assets/country_flags/${profile.phone.charCode}.png`}
											className={"w-[1rem] aspect-auto"}
											alt={profile.phone.countryName}
										/>
										<p
											className={""}
											aria-selected={"false"}
										>
											{profile.phone.dialingCode}
										</p>
										<ChevronDownIcon
											// onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
											className={`${isCountryCodeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
											aria-hidden="true"
											stroke="#292D32"
											strokeWidth={"0.1vh"}
										/>
									</button>

									{/* WhatsApp Number Input */}
									<input
										disabled={isVerifyPhoneNumberOtpSuccess}
										type="phone"
										name="phone"
										className=""
										placeholder="7734567890"
										value={profile.phone.number || ""}
										onChange={(e) => {
											setProfile(prev => ({
												...prev,
												[e.target.name]: {
													...prev.phone,
													number: e.target.value
												}
											}));

											setError(prev => ({
												...prev,
												[e.target.name]: ""
											}));
										}}
										onBlur={validatePhoneNumber}
										required
									/>
								</div>

								{/* Country Code Dropdown */}
								<div className={``}>
									<Transition show={isCountryCodeDropdownOpen}>
										<div
											className={`bg-white absolute left-0 right-0 z-[100]
                                                origin-top-right rounded-md shadow-2xl mt-[0.5vh]
                                                
                                                landscape:mx-[0.75rem] landscape:jk:mx-[0.9rem] landscape:lg:mx-[1.15rem]
                                                
                                                border border-gray-700
                                                data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                data-[enter]:duration-100 data-[enter]:ease-out 
                                                data-[leave]:duration-75 data-[leave]:ease-in`}
										>
											<div
												className={"w-full flex-1 overflow-hidden relative rounded-md"}>
												<div
													className="flex-1 flex flex-col max-h-[30vh] w-full overflow-y-scroll"
												>
													{
														countryCodes.map((country, index) => (
															<button
																key={index}
																className={`custom-input-dropdown-list-button`}
																onMouseDown={() => setIsSelectingCountryCode(true)}
																onClick={() => handleCountryCodeSelect(country)}
															>
																<img
																	src={country.countryFlagSrc}
																	alt={country.countryName}
																/>
																<p
																	className={`text-nowrap`}
																>
																	{`${country.countryName}  (${country.countryDialingCode})`}
																</p>
															</button>
														))
													}
												</div>
											</div>
										</div>
									</Transition>
								</div>
							</div>

							{error['phone'] && (
								<p
									id="phone-error"
									className="custom-input-error-message"
								>
									{error['phone']}
								</p>
							)}
						</div>

						{/* WhatsApp Number - Send OTP */}
						<button
							disabled={isSendPhoneNumberOtpButtonDisabled || isVerifyPhoneNumberOtpSuccess}
							onClick={sendOtpOnPhoneNumberButtonClick}
							className={`${!isSendPhoneNumberOtpButtonDisabled && 'arrow-button'}
                                w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                
                                portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                
                                hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                disabled:ring-0 disabled:ring-offset-0
                                transition-all duration-300 ease-in-out`}
						>
							<p
								className="line-clamp-1 text-white leading-tight font-custom-medium
                                    portrait:text-[1rem] portrait:md:text-[1rem]
                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
							>
								{
									isVerifyPhoneNumberOtpSuccess
										? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")
										: t("REGISTER_PAGE.OTP_BUTTON.SEND")
								}
							</p>
							{
								!isVerifyPhoneNumberOtpSuccess && (
									<svg
										viewBox="0 0 6 6"
										fill="none"
										id={"arrow-icon"}
										className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                            portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                            portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                            landscape:h-[0.65rem] landscape:w-[0.65rem]
                                            landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                            landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M3 1L5 3L3 5"
											id={"arrow-icon-tip"}
											stroke="white"
											strokeLinecap="square"
										/>
										<path
											d="M1 3L4 3"
											id={"arrow-icon-line"}
											stroke="white"
											strokeLinecap="square"
										/>
									</svg>
								)
							}
						</button>

						{/* WhatsApp Number - OTP Input | Verify OTP */}
						{isSendPhoneNumberOtpSuccess && (!isVerifyPhoneNumberOtpSuccess) && (
							<>
								{/* WhatsApp Number - OTP Input */}
								<div className="custom-input-container">
									<label htmlFor="phoneOtp">
										{t("REGISTER_PAGE.OTP_BUTTON.ENTER")}
									</label>

									<input
										type="text"
										name="phoneOtp"
										value={phoneNumberOtp}
										onChange={(e) => setPhoneNumberOtp(e.target.value)}
										id="otp"
										className={`custom-input`}
									/>
								</div>

								{/* WhatsApp Number - Verify OTP */}
								<button
									disabled={isVerifyPhoneNumberOtpButtonDisabled}
									onClick={verifyPhoneNumberOtpButtonClick}
									className={`${isVerifyPhoneNumberOtpButtonDisabled ? '' : 'arrow-button'} 
                                        w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                        landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                        
                                        portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                        landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                        
                                        hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                        disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                        disabled:ring-0 disabled:ring-offset-0
                                        transition-all duration-300 ease-in-out`}
								>
									<p
										className="line-clamp-1 text-white leading-tight font-custom-medium
                                            portrait:text-[1rem] portrait:md:text-[1rem]
                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
									>
										{t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}
									</p>
									<svg
										viewBox="0 0 6 6"
										fill="none"
										id={"arrow-icon"}
										className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                            portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                            portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                            landscape:h-[0.65rem] landscape:w-[0.65rem]
                                            landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                            landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M3 1L5 3L3 5"
											id={"arrow-icon-tip"}
											stroke="white"
											strokeLinecap="square"
										/>
										<path
											d="M1 3L4 3"
											id={"arrow-icon-line"}
											stroke="white"
											strokeLinecap="square"
										/>
									</svg>
								</button>
							</>
						)}
					</fieldset>
				);

			default:
				return null;
		}
	}

	return (
		<>
			{showFindMyProfile && (
				<div
					className="fixed inset-0 z-[200] flex items-end sm:items-center justify-center sm:p-4
                        transition-opacity duration-220"
					style={{
						background: "rgba(0,0,0,0.55)",
						backdropFilter: "blur(4px)",
						opacity: popupVisible ? 1 : 0,
					}}
				>
					<div
						className="w-full sm:max-w-md transition-all duration-220"
						style={{
							transform: popupVisible
								? "translateY(0) scale(1)"
								: "translateY(1.5rem) scale(0.97)",
							opacity: popupVisible ? 1 : 0,
						}}
					>
						<FindMyProfilePopup onClose={handleClosePopup}/>
					</div>
				</div>
			)}

			{/* Register Page */}
			<div className="h-[100dvh] w-full flex flex-row items-center justify-center">
				{/* Background */}
				<div className="absolute inset-0 h-dvh">
					<img
						src="/assets/home-page-hero-section-bg.png"
						alt=""
						className="absolute w-full h-full object-bottom object-cover shadow-lg"
					/>
					<div
						className="absolute h-full w-full flex
                        items-end portrait:justify-center landscape:px-[4rem]"
					>
						<img
							src="/assets/hero-section-home-page-banner-statue.png"
							alt=""
							className="portrait:h-[20%] portrait:xs:h-[22.5%]
                                portrait:md:h-[27.5%] portrait:jk:h-[37.5%] portrait:lg:h-[50%]
                                landscape:h-[50%] landscape:jk:h-[60%] landscape:lg:h-[70%]
                                aspect-auto object-contain"
						/>
						<img
							src="/assets/hero-section-home-page-title.svg"
							alt=""
							className="portrait:h-[13%] portrait:xs:h-[15%]
                                portrait:md:h-[20%] portrait:jk:h-[27.5%] portrait:lg:h-[37.5%]
                                landscape:h-[35%] landscape:jk:h-[42.5%] landscape:lg:h-[50%]
                                aspect-auto object-contain
                                portrait:mb-[2rem] landscape:mb-[2rem]"
						/>
					</div>
				</div>

				{/* Register Card */}
				<div
					className="z-10 h-full w-full flex flex-1
                        flex-col items-center justify-start landscape:items-end
                        portrait:py-[2rem] portrait:px-[1rem]
                        portrait:jk:p-[3.5rem] portrait:lg:p-[5rem]
                        landscape:p-[1.5rem] landscape:jk:p-[1.75rem] landscape:lg:p-[2rem]"
				>
					<div
						className="flex flex-col bg-white max-h-full
                            landscape:fixed portrait:max-h-[70vh]
                            portrait:w-full portrait:sm:w-[27.5rem] portrait:jk:w-[35rem] portrait:lg:w-[40rem]

                            portrait:rounded-xl landscape:rounded-xl

                            landscape:w-[18.75rem] landscape:xs:w-[21.5rem] landscape:md:w-[22.5rem]
                            landscape:jk:w-[27.5rem] landscape:lg:w-[30rem]
                            shadow-[0_13px_27px_-5px_#32325d40,_0_8px_16px_-8px_#0000004d]"
					>
						{/* Header */}
						<div className={`form-modal-header-container`}>
							<div className={`flex flex-col gap-y-[0.45rem]`}>
								<h1
									className="leading-tight font-custom-bold text-gray-900
                                    portrait:text-[1.5rem] portrait:sm:text-[1.65rem]
                                    portrait:jk:text-[2rem] portrait:lg:text-[2.75rem]
                                    landscape:text-[1.25rem] landscape:md:text-[1.45rem]
                                    landscape:jk:text-[1.45rem] landscape:lg:text-[1.75rem]"
								>
									{t("REGISTER_PAGE.GREETING.MAIN")}
								</h1>

								{/*<p*/}
								{/*    className="leading-tight font-custom-semi-bold text-gray-500*/}
								{/*        portrait:text-[1rem] portrait:sm:text-[1.25rem]*/}
								{/*        portrait:jk:text-[1.5rem] portrait:lg:text-[2rem]*/}
								{/*        landscape:text-[0.85rem] landscape:jk:text-[1rem]*/}
								{/*        landscape:lg:text-[1.225rem]"*/}
								{/*>*/}
								{/*    {t("REGISTER_PAGE.GREETING.SUB")}*/}
								{/*</p>*/}

								{/* Divider */}
								<div className={"h-[0.1rem] w-full bg-[#ECECEC] rounded-full"}/>
							</div>

							{renderProgressBar()}
						</div>

						{/* Form - Body */}
						<div
							className={`
                                landscape:max-h-[60vh] portrait:flex-1 portrait:md:max-h-[60vh]
                                
                                portrait:gap-[1rem] portrait:jk:gap-[1.25rem] portrait:lg:gap-[1.75rem]
                                landscape:gap-[0.75rem] landscape:jk:gap-[0.9rem] landscape:lg:gap-[1rem]
                                
                                portrait:px-[1.25rem] portrait:py-[1rem]
                                portrait:jk:px-[1.75rem] portrait:jk:py-[1.5rem]
                                portrait:lg:px-[2.25rem] portrait:lg:py-[2rem]
                                
                                landscape:px-[0.75rem] landscape:py-[0.5rem]
                                landscape:jk:px-[0.9rem] landscape:jk:py-[0.6rem]
                                landscape:lg:px-[1.15rem] landscape:lg:py-[0.75rem]
                            `}
						>
							{renderRegistrationSteps()}

							{/* Full Name | Column Based */}
							{/*<fieldset className={"w-full"}>*/}
							{/*    <div*/}
							{/*        className="!flex-1 !w-full custom-input-container"*/}
							{/*    >*/}
							{/*        /!* Label *!/*/}
							{/*        <label htmlFor="firstName">*/}
							{/*            {t("REGISTER_PAGE.NAME.LABEL.BASE")}*/}
							{/*        </label>*/}

							{/*        /!* Input Fields *!/*/}
							{/*        <div className="custom-input-multiple-fields-container">*/}
							{/*            /!* First Name *!/*/}
							{/*            /!*<div className="flex-1 flex flex-col gap-1">*!/*/}
							{/*            <input*/}
							{/*                id="firstName"*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                name='firstName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.FIRST_NAME")}*/}
							{/*                value={profile.firstName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*            /!*</div>*!/*/}

							{/*            /!* Middle Name *!/*/}
							{/*            /!*<div className="flex-1 flex flex-col gap-1">*!/*/}
							{/*            <input*/}
							{/*                id="middleName"*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                name='middleName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.MIDDLE_NAME")}*/}
							{/*                value={profile.middleName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*            /!*</div>*!/*/}

							{/*            /!* Last Name *!/*/}
							{/*            /!*<div className="flex-1 flex flex-col gap-1">*!/*/}
							{/*            <input*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                id="lastName"*/}
							{/*                name='lastName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.LAST_NAME")}*/}
							{/*                value={profile.lastName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*            /!*</div>*!/*/}
							{/*        </div>*/}

							{/*        /!* Error Container *!/*/}
							{/*        {*/}
							{/*            (error['firstName'] !== '' || error['middleName'] !== '' || error['lastName'] !== '') && (*/}
							{/*                <div*/}
							{/*                    className="custom-input-multiple-fields-container portrait:hidden"*/}
							{/*                >*/}
							{/*                    <p*/}
							{/*                        className="flex-1 text-red-600 font-custom-regular*/}
							{/*                            portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                            landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                            landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                        id="error"*/}
							{/*                    >*/}
							{/*                        {error['firstName'] ? error['firstName'] : ''}*/}
							{/*                    </p>*/}

							{/*                    <p*/}
							{/*                        className="flex-1 text-red-600 font-custom-regular*/}
							{/*                            portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                            landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                            landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                        id="error"*/}
							{/*                    >*/}
							{/*                        {error['middleName'] ? error['middleName'] : ''}*/}
							{/*                    </p>*/}

							{/*                    <p*/}
							{/*                        className="flex-1 text-red-600 font-custom-regular*/}
							{/*                            portrait:text-[0.625rem] portrait:md:text-[0.9rem]*/}
							{/*                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]*/}
							{/*                            landscape:text-[0.45rem] landscape:md:text-[0.5rem]*/}
							{/*                            landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"*/}
							{/*                        id="error"*/}
							{/*                    >*/}
							{/*                        {error['lastName'] ? error['lastName'] : ''}*/}
							{/*                    </p>*/}
							{/*                </div>*/}
							{/*            )*/}
							{/*        }*/}

							{/*        /!* Is Member of Joglekarkul 2010 Granth *!/*/}
							{/*        {*/}
							{/*            (profile.lastName.trim().toLowerCase() === 'joglekar' || isJoglekarMaherVashin) && (*/}
							{/*                <label className="custom-input-label-checkbox">*/}
							{/*                    <input*/}
							{/*                        type="checkbox"*/}
							{/*                        name='isJoglekarMaherVashin'*/}
							{/*                        checked={isMemberOfJoglekarKul2010Granth}*/}
							{/*                        onChange={() => setIsMemberOfJoglekarKul2010Granth(!isMemberOfJoglekarKul2010Granth)}*/}
							{/*                    />*/}
							{/*                    <p>*/}
							{/*                        {t("REGISTER_PAGE.MEMBER_OF_JOGLEKARKUL_2010_GRANTH.LABEL")}*/}
							{/*                    </p>*/}
							{/*                </label>*/}
							{/*            )*/}
							{/*        }*/}
							{/*    </div>*/}
							{/*</fieldset>*/}

							{/* Full Name */}
							{/*<fieldset className={`w-full flex flex-col multiple-fields-container-gap`}>*/}
							{/*    /!* First Name *!/*/}
							{/*    <div className="!flex-1 !w-full custom-input-container">*/}
							{/*        /!* Label *!/*/}
							{/*        <label htmlFor="firstName">*/}
							{/*            {t("REGISTER_PAGE.NAME.LABEL.BASE.FIRST_NAME")}*/}
							{/*        </label>*/}

							{/*        /!* Input Container *!/*/}
							{/*        <div className="flex-1 flex flex-col gap-1">*/}
							{/*            <input*/}
							{/*                id="firstName"*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                name='firstName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.FIRST_NAME")}*/}
							{/*                value={profile.firstName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*        </div>*/}
							{/*    </div>*/}

							{/*    /!* Middle Name *!/*/}
							{/*    <div className="!flex-1 !w-full custom-input-container">*/}
							{/*        /!* Label *!/*/}
							{/*        <label htmlFor="firstName">*/}
							{/*            {t("REGISTER_PAGE.NAME.LABEL.BASE.MIDDLE_NAME")}*/}
							{/*        </label>*/}

							{/*        /!* Input Container *!/*/}
							{/*        <div className="flex-1 flex flex-col gap-1">*/}
							{/*            <input*/}
							{/*                id="middleName"*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                name='middleName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.MIDDLE_NAME")}*/}
							{/*                value={profile.middleName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*        </div>*/}
							{/*    </div>*/}

							{/*    /!* Last Name *!/*/}
							{/*    <div className="!flex-1 !w-full custom-input-container">*/}
							{/*        /!* Label *!/*/}
							{/*        <label htmlFor="firstName">*/}
							{/*            {t("REGISTER_PAGE.NAME.LABEL.BASE.LAST_NAME")}*/}
							{/*        </label>*/}

							{/*        /!* Input Container *!/*/}
							{/*        <div className="flex-1 flex flex-col gap-1">*/}
							{/*            <input*/}
							{/*                className={"custom-input w-full"}*/}
							{/*                id="lastName"*/}
							{/*                name='lastName'*/}
							{/*                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.LAST_NAME")}*/}
							{/*                value={profile.lastName}*/}
							{/*                onChange={handleFormData}*/}
							{/*                onFocus={() => {*/}
							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        firstName: "",*/}
							{/*                        middleName: "",*/}
							{/*                        lastName: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={translateToDevanagri}*/}
							{/*            />*/}
							{/*        </div>*/}
							{/*    </div>*/}
							{/*</fieldset>*/}

							{/*<fieldset className={"w-full flex-1"}>*/}
							{/*    /!* Are you a Member of Joglekarkul 2010 Granth *!/*/}
							{/*    {*/}
							{/*        (profile.lastName.trim().toLowerCase() === 'joglekar' || isJoglekarMaherVashin) && (*/}
							{/*            <label className="custom-input-label-checkbox">*/}
							{/*                <input*/}
							{/*                    type="checkbox"*/}
							{/*                    name='isJoglekarMaherVashin'*/}
							{/*                    checked={isMemberOfJoglekarKul2010Granth}*/}
							{/*                    onChange={() => setIsMemberOfJoglekarKul2010Granth(!isMemberOfJoglekarKul2010Granth)}*/}
							{/*                />*/}
							{/*                <p>*/}
							{/*                    {t("REGISTER_PAGE.MEMBER_OF_JOGLEKARKUL_2010_GRANTH.LABEL")}*/}
							{/*                </p>*/}
							{/*            </label>*/}
							{/*        )*/}
							{/*    }*/}
							{/*    /!* Date of Birth | Family Tree Name *!/*/}

							{/*</fieldset>*/}

							{/* Gender | Marital Status */}
							{/*<div className="custom-input-multiple-fields-container w-full">*/}
							{/*    /!* Gender *!/*/}
							{/*    <div className="custom-input-container">*/}
							{/*        /!* Gender Label *!/*/}
							{/*        <label htmlFor="gender">*/}
							{/*            {t("REGISTER_PAGE.GENDER.LABEL")}*/}
							{/*        </label>*/}

							{/*        /!* Gender Button | Dropdown *!/*/}
							{/*        <div className="h-full w-full flex flex-col">*/}
							{/*            <button*/}
							{/*                onBlur={() => {*/}
							{/*                    if (!isSelectingGender) {*/}
							{/*                        setIsGenderDropdownOpen(false);*/}
							{/*                    }*/}
							{/*                }}*/}
							{/*                className={`custom-input-dropdown-button*/}
							{/*            ${isGenderDropdownOpen ? 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]' : ''}`}*/}
							{/*                onClick={() => setIsGenderDropdownOpen(!isGenderDropdownOpen)}*/}
							{/*            >*/}
							{/*                <div>*/}
							{/*                    <p>*/}
							{/*                        {*/}
							{/*                            profile.gender === "Male"*/}
							{/*                                ? t("REGISTER_PAGE.GENDER.MALE")*/}
							{/*                                : t("REGISTER_PAGE.GENDER.FEMALE")*/}
							{/*                        }*/}
							{/*                    </p>*/}
							{/*                    <img*/}
							{/*                        src={profile.gender === "Male" ? "assets/male-gender-icon.png" : "assets/female-gender-icon.png"}*/}
							{/*                        alt={profile.gender === "Male" ? "Male" : "Female"}*/}
							{/*                    />*/}
							{/*                </div>*/}
							{/*                <ChevronDownIcon*/}
							{/*                    className={`${isGenderDropdownOpen ? 'rotate-180' : 'rotate-0'} `}*/}
							{/*                    aria-hidden="true"*/}
							{/*                    stroke="#292D32"*/}
							{/*                    strokeWidth={"0.1vh"}*/}
							{/*                />*/}
							{/*            </button>*/}

							{/*            /!* Gender Dropdown *!/*/}
							{/*            <div className={"relative mt-[0.5vh]"}>*/}
							{/*                <Transition show={isGenderDropdownOpen}>*/}
							{/*                    <div*/}
							{/*                        className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]*/}
							{/*                        origin-top-right rounded-md shadow-2xl */}
							{/*                        border border-gray-700 overflow-y-scroll*/}
							{/*                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 */}
							{/*                        data-[enter]:duration-100 data-[enter]:ease-out */}
							{/*                        data-[leave]:duration-75 data-[leave]:ease-in`}*/}
							{/*                    >*/}
							{/*                        <button*/}
							{/*                            className="custom-input-dropdown-list-button"*/}
							{/*                            onClick={() => handleGenderSelect("Male")}*/}
							{/*                            onMouseDown={() => setIsSelectingGender(true)}*/}
							{/*                        >*/}
							{/*                            <p>*/}
							{/*                                {t("REGISTER_PAGE.GENDER.MALE")}*/}
							{/*                            </p>*/}
							{/*                            <img*/}
							{/*                                src={"assets/male-gender-icon.png"}*/}
							{/*                                alt={"Male"}*/}
							{/*                            />*/}
							{/*                        </button>*/}
							{/*                        <button*/}
							{/*                            className="custom-input-dropdown-list-button"*/}
							{/*                            onClick={() => handleGenderSelect("Female")}*/}
							{/*                            onMouseDown={() => setIsSelectingGender(true)}*/}
							{/*                        >*/}
							{/*                            <p>*/}
							{/*                                {t("REGISTER_PAGE.GENDER.FEMALE")}*/}
							{/*                            </p>*/}
							{/*                            <img*/}
							{/*                                src={"assets/female-gender-icon.png"}*/}
							{/*                                alt={"Female"}*/}
							{/*                            />*/}
							{/*                        </button>*/}
							{/*                    </div>*/}
							{/*                </Transition>*/}
							{/*            </div>*/}
							{/*        </div>*/}
							{/*    </div>*/}

							{/*    /!* Marital Status *!/*/}
							{/*    <div className="custom-input-container">*/}
							{/*        /!* Marital Status Label *!/*/}
							{/*        <label htmlFor="maritalStatus">*/}
							{/*            <img*/}
							{/*                src={"assets/marriage-icon.png"}*/}
							{/*                alt={"Marriage"}*/}
							{/*                title={"Marriage"}*/}
							{/*            />*/}
							{/*            {t("REGISTER_PAGE.MARITAL_STATUS.LABEL")}*/}
							{/*        </label>*/}

							{/*        /!* Marital Status Button | Dropdown *!/*/}
							{/*        <div className="h-full w-full flex flex-col">*/}
							{/*            <button*/}
							{/*                onBlur={() => {*/}
							{/*                    if (!isSelectingMaritalStatus) {*/}
							{/*                        setIsMaritalStatusDropdownOpen(false);*/}
							{/*                    }*/}
							{/*                }}*/}
							{/*                className={`custom-input-dropdown-button*/}
							{/*                ${isMaritalStatusDropdownOpen && 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]'}`}*/}
							{/*                onClick={() => setIsMaritalStatusDropdownOpen(!isMaritalStatusDropdownOpen)}*/}
							{/*            >*/}
							{/*                <p>*/}
							{/*                    {maritalStatusLabel(profile.maritalStatus)}*/}
							{/*                </p>*/}
							{/*                <ChevronDownIcon*/}
							{/*                    className={`${isMaritalStatusDropdownOpen ? 'rotate-180' : 'rotate-0'} `}*/}
							{/*                    aria-hidden="true"*/}
							{/*                    stroke="#292D32"*/}
							{/*                    strokeWidth={"0.1vh"}*/}
							{/*                />*/}
							{/*            </button>*/}

							{/*            /!* Marital Status Dropdown *!/*/}
							{/*            <div className={"relative mt-[0.5vh]"}>*/}
							{/*                <Transition show={isMaritalStatusDropdownOpen}>*/}
							{/*                    <div*/}
							{/*                        className={`bg-white absolute left-0 right-0 z-[100] */}
							{/*                        max-h-[5rem] origin-top-right rounded-md shadow-2xl */}
							{/*                        border border-gray-700 overflow-y-scroll*/}
							{/*                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 */}
							{/*                        data-[enter]:duration-100 data-[enter]:ease-out */}
							{/*                        data-[leave]:duration-75 data-[leave]:ease-in`}*/}
							{/*                    >*/}
							{/*                        {*/}
							{/*                            maritalStatusOptions.map((option, index) => (*/}
							{/*                                <button*/}
							{/*                                    className="custom-input-dropdown-list-button"*/}
							{/*                                    onClick={() => handleMaritalStatusSelect(option.value)}*/}
							{/*                                    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
							{/*                                >*/}
							{/*                                    <p>*/}
							{/*                                        {option.label}*/}
							{/*                                    </p>*/}
							{/*                                </button>*/}
							{/*                            ))*/}
							{/*                        }*/}
							{/*                        /!*<button*!/*/}
							{/*                        /!*    className="custom-input-dropdown-list-button"*!/*/}
							{/*                        /!*    onClick={() => handleMaritalStatusSelect("Minor")}*!/*/}
							{/*                        /!*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*!/*/}
							{/*                        /!*>*!/*/}
							{/*                        /!*    <p>*!/*/}
							{/*                        /!*        {t("REGISTER_PAGE.MARITAL_STATUS.MINOR")}*!/*/}
							{/*                        /!*    </p>*!/*/}
							{/*                        /!*</button>*!/*/}
							{/*                        /!*<button*!/*/}
							{/*                        /!*    className="custom-input-dropdown-list-button"*!/*/}
							{/*                        /!*    onClick={() => handleMaritalStatusSelect("Single")}*!/*/}
							{/*                        /!*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*!/*/}
							{/*                        /!*>*!/*/}
							{/*                        /!*    <p>*!/*/}
							{/*                        /!*        {t("REGISTER_PAGE.MARITAL_STATUS.SINGLE")}*!/*/}
							{/*                        /!*    </p>*!/*/}
							{/*                        /!*</button>*!/*/}
							{/*                        /!*<button*!/*/}
							{/*                        /!*    className="custom-input-dropdown-list-button"*!/*/}
							{/*                        /!*    onClick={() => handleMaritalStatusSelect("Married")}*!/*/}
							{/*                        /!*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*!/*/}
							{/*                        /!*>*!/*/}
							{/*                        /!*    <p>*!/*/}
							{/*                        /!*        {t("REGISTER_PAGE.MARITAL_STATUS.MARRIED")}*!/*/}
							{/*                        /!*    </p>*!/*/}
							{/*                        /!*</button>*!/*/}
							{/*                        /!*<button*!/*/}
							{/*                        /!*    className="custom-input-dropdown-list-button"*!/*/}
							{/*                        /!*    onClick={() => profile.gender === "Male"*!/*/}
							{/*                        /!*        ? handleMaritalStatusSelect("Widower")*!/*/}
							{/*                        /!*        : handleMaritalStatusSelect("Widowed")}*!/*/}
							{/*                        /!*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*!/*/}
							{/*                        /!*>*!/*/}
							{/*                        /!*    <p>*!/*/}
							{/*                        /!*        {*!/*/}
							{/*                        /!*            profile.gender === "Male"*!/*/}
							{/*                        /!*                ? t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER")*!/*/}
							{/*                        /!*                : t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED")*!/*/}
							{/*                        /!*        }*!/*/}
							{/*                        /!*    </p>*!/*/}
							{/*                        /!*</button>*!/*/}
							{/*                        /!*<button*!/*/}
							{/*                        /!*    className="custom-input-dropdown-list-button"*!/*/}
							{/*                        /!*    onClick={() => handleMaritalStatusSelect("Divorced")}*!/*/}
							{/*                        /!*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*!/*/}
							{/*                        /!*>*!/*/}
							{/*                        /!*    <p>*!/*/}
							{/*                        /!*        {t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED")}*!/*/}
							{/*                        /!*    </p>*!/*/}
							{/*                        /!*</button>*!/*/}
							{/*                    </div>*/}
							{/*                </Transition>*/}
							{/*            </div>*/}
							{/*        </div>*/}
							{/*    </div>*/}
							{/*</div>*/}

							{/* Is MaherVashin */}
							{/*{*/}
							{/*    profile.lastName.trim().toLowerCase() !== 'joglekar' && profile.gender === 'Female'*/}
							{/*    && (profile.maritalStatus === 'Married' || profile.maritalStatus === 'Divorced' || profile.maritalStatus === 'Widowed') && (*/}
							{/*        <label className="custom-input-label-checkbox">*/}
							{/*            <input*/}
							{/*                type="checkbox"*/}
							{/*                name='isJoglekarMaherVashin'*/}
							{/*                checked={isJoglekarMaherVashin}*/}
							{/*                onChange={() => setIsJoglekarMaheVashin(!isJoglekarMaherVashin)}*/}
							{/*            />*/}
							{/*            <p>*/}
							{/*                {t("REGISTER_PAGE.IS_MAHER_VASHIN")}*/}
							{/*            </p>*/}
							{/*        </label>*/}
							{/*    )*/}
							{/*}*/}

							{/* Email Input | Send OTP Button */}
							{/*{*/}
							{/*    !isSeniorCitizen && (*/}
							{/*        <>*/}
							{/*            /!* Email Input  *!/*/}
							{/*            <div className="custom-input-container">*/}
							{/*                <label htmlFor="email">*/}
							{/*                    {t("REGISTER_PAGE.EMAIL_INPUT.LABEL")}*/}
							{/*                </label>*/}

							{/*                <input*/}
							{/*                    disabled={isVerifyEmailOtpSuccess}*/}
							{/*                    type="email"*/}
							{/*                    name="email"*/}
							{/*                    value={profile.email}*/}
							{/*                    onChange={handleFormData}*/}
							{/*                    id="email"*/}
							{/*                    className={`custom-input`}*/}
							{/*                    onBlur={validateEmailId}*/}
							{/*                />*/}

							{/*                {error['email'] && (*/}
							{/*                    <p className="custom-input-error-message" id="email-error">*/}
							{/*                        {error['email']}*/}
							{/*                    </p>*/}
							{/*                )}*/}
							{/*            </div>*/}

							{/*            /!* Email - Send OTP *!/*/}
							{/*            <button*/}
							{/*                disabled={isSendEmailOtpButtonDisabled || isVerifyEmailOtpSuccess}*/}
							{/*                onClick={sendOtpOnEmailButtonClick}*/}
							{/*                className={`${!isSendEmailOtpButtonDisabled && 'arrow-button'}*/}
							{/*                w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]*/}
							{/*                landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg*/}
							{/*                */}
							{/*                portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]*/}
							{/*                landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]*/}
							{/*                */}
							{/*                hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 */}
							{/*                disabled:cursor-not-allowed disabled:bg-slate-400/50 */}
							{/*                disabled:ring-0 disabled:ring-offset-0*/}
							{/*                transition-all duration-300 ease-in-out`}*/}
							{/*            >*/}
							{/*                <p*/}
							{/*                    className="line-clamp-1 text-white leading-tight font-custom-medium*/}
							{/*                    portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
							{/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
							{/*                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"*/}
							{/*                >*/}
							{/*                    {*/}
							{/*                        isVerifyEmailOtpSuccess*/}
							{/*                            ? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")*/}
							{/*                            : t("REGISTER_PAGE.OTP_BUTTON.SEND")*/}
							{/*                    }*/}
							{/*                </p>*/}
							{/*                {*/}
							{/*                    !isVerifyEmailOtpSuccess && (*/}
							{/*                        <svg*/}
							{/*                            viewBox="0 0 6 6"*/}
							{/*                            fill="none"*/}
							{/*                            id={"arrow-icon"}*/}
							{/*                            className="portrait:h-[1rem] portrait:md:h-[0.9rem]*/}
							{/*                            portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]*/}
							{/*                            landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]*/}
							{/*                            aspect-square"*/}
							{/*                            xmlns="http://www.w3.org/2000/svg"*/}
							{/*                        >*/}
							{/*                            <path*/}
							{/*                                d="M3 1L5 3L3 5"*/}
							{/*                                id={"arrow-icon-tip"}*/}
							{/*                                stroke="white"*/}
							{/*                                strokeLinecap="square"*/}
							{/*                            />*/}
							{/*                            <path*/}
							{/*                                d="M1 3L4 3"*/}
							{/*                                id={"arrow-icon-line"}*/}
							{/*                                stroke="white"*/}
							{/*                                strokeLinecap="square"*/}
							{/*                            />*/}
							{/*                        </svg>*/}
							{/*                    )*/}
							{/*                }*/}
							{/*            </button>*/}
							{/*        </>*/}

							{/*    )*/}
							{/*}*/}

							{/* Email - OTP Input | Verify OTP */}
							{/*{isSendEmailOtpSuccess && (!isVerifyEmailOtpSuccess) && (*/}
							{/*    <>*/}
							{/*        /!* Email - OTP Input *!/*/}
							{/*        <div className="custom-input-container">*/}
							{/*            <label*/}
							{/*                htmlFor="emailOtp"*/}
							{/*            >*/}
							{/*                {t("REGISTER_PAGE.OTP_BUTTON.ENTER")}*/}
							{/*            </label>*/}
							{/*            <div*/}
							{/*                className="flex portrait:gap-2 portrait:jk:gap-4 landscape:gap-2"*/}
							{/*            >*/}
							{/*                <input*/}
							{/*                    type="text"*/}
							{/*                    name="emailOtp"*/}
							{/*                    value={emailOtp}*/}
							{/*                    onChange={(e) => setEmailOtp(e.target.value)}*/}
							{/*                    id="otp"*/}
							{/*                    className={`custom-input`}*/}
							{/*                />*/}
							{/*            </div>*/}
							{/*        </div>*/}

							{/*        /!* Email - Verify OTP *!/*/}
							{/*        <button*/}
							{/*            disabled={isVerifyEmailOtpButtonDisabled}*/}
							{/*            onClick={verifyEmailOtpButtonClick}*/}
							{/*            className={`${isVerifyEmailOtpButtonDisabled ? '' : 'arrow-button'} */}
							{/*            w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]*/}
							{/*            landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg*/}
							{/*            */}
							{/*            portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]*/}
							{/*            landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]*/}
							{/*            */}
							{/*            hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 */}
							{/*            disabled:cursor-not-allowed disabled:bg-slate-400/50 */}
							{/*            disabled:ring-0 disabled:ring-offset-0*/}
							{/*            transition-all duration-300 ease-in-out`}*/}
							{/*        >*/}
							{/*            <p*/}
							{/*                className="line-clamp-1 text-white leading-tight font-custom-medium*/}
							{/*                portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
							{/*                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
							{/*                landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"*/}
							{/*            >*/}
							{/*                {t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}*/}
							{/*            </p>*/}
							{/*            <svg*/}
							{/*                viewBox="0 0 6 6"*/}
							{/*                fill="none"*/}
							{/*                id={"arrow-icon"}*/}
							{/*                className="portrait:h-[1rem] portrait:md:h-[0.9rem]*/}
							{/*                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]*/}
							{/*                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]*/}
							{/*                aspect-square"*/}
							{/*                xmlns="http://www.w3.org/2000/svg"*/}
							{/*            >*/}
							{/*                <path*/}
							{/*                    d="M3 1L5 3L3 5"*/}
							{/*                    id={"arrow-icon-tip"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*                <path*/}
							{/*                    d="M1 3L4 3"*/}
							{/*                    id={"arrow-icon-line"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*            </svg>*/}
							{/*        </button>*/}
							{/*    </>*/}
							{/*)}*/}

							{/* WhatsApp Number */}
							{/*<div className="custom-phone-number-input">*/}
							{/*    <label htmlFor="phone">*/}
							{/*        {t("REGISTER_PAGE.PHONE_INPUT.LABEL")}*/}
							{/*    </label>*/}
							{/*    <div*/}
							{/*        className="flex-1 flex flex-col*/}
							{/*            portrait:gap-2 portrait:jk:gap-4 landscape:gap-2"*/}
							{/*    >*/}
							{/*        /!* Country Code | WhatsApp Number Input *!/*/}
							{/*        <div className="custom-phone-number-input-container">*/}
							{/*            <button*/}
							{/*                disabled={isVerifyPhoneNumberOtpSuccess}*/}
							{/*                onBlur={() => {*/}
							{/*                    if (!isSelectingCountryCode) {*/}
							{/*                        setIsCountryCodeDropdownOpen(false);*/}
							{/*                    }*/}
							{/*                }}*/}
							{/*                onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}*/}
							{/*            >*/}
							{/*                <img*/}
							{/*                    src={`assets/country_flags/${profile.phone.charCode}.png`}*/}
							{/*                    className={"w-[1rem] aspect-auto"}*/}
							{/*                    alt={profile.phone.countryName}*/}
							{/*                />*/}
							{/*                <p*/}
							{/*                    className={""}*/}
							{/*                    aria-selected={"false"}*/}
							{/*                >*/}
							{/*                    {profile.phone.dialingCode}*/}
							{/*                </p>*/}
							{/*                <ChevronDownIcon*/}
							{/*                    // onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}*/}
							{/*                    className={`${isCountryCodeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}*/}
							{/*                    aria-hidden="true"*/}
							{/*                    stroke="#292D32"*/}
							{/*                    strokeWidth={"0.1vh"}*/}
							{/*                />*/}
							{/*            </button>*/}
							{/*            <input*/}
							{/*                disabled={isVerifyPhoneNumberOtpSuccess}*/}
							{/*                type="phone"*/}
							{/*                name="phone"*/}
							{/*                className=""*/}
							{/*                placeholder="7734567890"*/}
							{/*                value={profile.phone.number || ""}*/}
							{/*                onChange={(e) => {*/}
							{/*                    setProfile(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        [e.target.name]: {*/}
							{/*                            ...prev.phone,*/}
							{/*                            number: e.target.value*/}
							{/*                        }*/}
							{/*                    }));*/}

							{/*                    setError(prev => ({*/}
							{/*                        ...prev,*/}
							{/*                        [e.target.name]: ""*/}
							{/*                    }));*/}
							{/*                }}*/}
							{/*                onBlur={validatePhoneNumber}*/}
							{/*                required*/}
							{/*            />*/}
							{/*        </div>*/}

							{/*        /!* Country Code Dropdown *!/*/}
							{/*        <div className={``}>*/}
							{/*            <Transition show={isCountryCodeDropdownOpen}>*/}
							{/*                <div*/}
							{/*                    className={`bg-white absolute left-0 right-0 z-[100]*/}
							{/*                            origin-top-right rounded-md shadow-2xl mt-[0.5vh]*/}
							{/*                            */}
							{/*                            portrait:mx-[2.25rem] portrait:jk:mx-[2.75rem] portrait:lg:mx-[3.25rem]*/}
							{/*                            landscape:mx-[0.75rem] landscape:jk:mx-[0.9rem] landscape:lg:mx-[1.15rem]*/}
							{/*                            */}
							{/*                            border border-gray-700*/}
							{/*                            data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 */}
							{/*                            data-[enter]:duration-100 data-[enter]:ease-out */}
							{/*                            data-[leave]:duration-75 data-[leave]:ease-in`}*/}
							{/*                >*/}
							{/*                    <div*/}
							{/*                        className={"w-full flex-1 overflow-hidden relative rounded-md"}>*/}
							{/*                        <div*/}
							{/*                            className="flex-1 flex flex-col max-h-[30vh] w-full overflow-y-scroll"*/}
							{/*                        >*/}
							{/*                            {*/}
							{/*                                countryCodes.map((country, index) => (*/}
							{/*                                    <button*/}
							{/*                                        key={index}*/}
							{/*                                        className={`custom-input-dropdown-list-button`}*/}
							{/*                                        onMouseDown={() => setIsSelectingCountryCode(true)}*/}
							{/*                                        onClick={() => handleCountryCodeSelect(country)}*/}
							{/*                                    >*/}
							{/*                                        <img*/}
							{/*                                            src={country.countryFlagSrc}*/}
							{/*                                            alt={country.countryName}*/}
							{/*                                        />*/}
							{/*                                        <p*/}
							{/*                                            className={`text-nowrap`}*/}
							{/*                                        >*/}
							{/*                                            {`${country.countryName}  (${country.countryDialingCode})`}*/}
							{/*                                        </p>*/}
							{/*                                    </button>*/}
							{/*                                ))*/}
							{/*                            }*/}
							{/*                        </div>*/}
							{/*                    </div>*/}
							{/*                </div>*/}
							{/*            </Transition>*/}
							{/*        </div>*/}
							{/*    </div>*/}

							{/*    {error['phone'] && (*/}
							{/*        <p*/}
							{/*            id="email-error"*/}
							{/*            className="custom-input-error-message"*/}
							{/*        >*/}
							{/*            {error['phone']}*/}
							{/*        </p>*/}
							{/*    )}*/}
							{/*</div>*/}

							{/* WhatsApp Number - Send OTP */}
							{/*<button*/}
							{/*    disabled={isSendPhoneNumberOtpButtonDisabled || isVerifyPhoneNumberOtpSuccess}*/}
							{/*    onClick={sendOtpOnPhoneNumberButtonClick}*/}
							{/*    className={`${!isSendPhoneNumberOtpButtonDisabled && 'arrow-button'}*/}
							{/*            w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]*/}
							{/*            landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg*/}
							{/*            */}
							{/*            portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]*/}
							{/*            landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]*/}
							{/*            */}
							{/*            hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 */}
							{/*            disabled:cursor-not-allowed disabled:bg-slate-400/50 */}
							{/*            disabled:ring-0 disabled:ring-offset-0*/}
							{/*            transition-all duration-300 ease-in-out`}*/}
							{/*>*/}
							{/*    <p*/}
							{/*        className="line-clamp-1 text-white leading-tight font-custom-medium*/}
							{/*                portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
							{/*                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
							{/*                landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"*/}
							{/*    >*/}
							{/*        {*/}
							{/*            isVerifyPhoneNumberOtpSuccess*/}
							{/*                ? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")*/}
							{/*                : t("REGISTER_PAGE.OTP_BUTTON.SEND")*/}
							{/*        }*/}
							{/*    </p>*/}
							{/*    {*/}
							{/*        !isVerifyPhoneNumberOtpSuccess && (*/}
							{/*            <svg*/}
							{/*                viewBox="0 0 6 6"*/}
							{/*                fill="none"*/}
							{/*                id={"arrow-icon"}*/}
							{/*                className="portrait:h-[1rem] portrait:md:h-[0.9rem]*/}
							{/*                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]*/}
							{/*                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]*/}
							{/*                aspect-square"*/}
							{/*                xmlns="http://www.w3.org/2000/svg"*/}
							{/*            >*/}
							{/*                <path*/}
							{/*                    d="M3 1L5 3L3 5"*/}
							{/*                    id={"arrow-icon-tip"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*                <path*/}
							{/*                    d="M1 3L4 3"*/}
							{/*                    id={"arrow-icon-line"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*            </svg>*/}
							{/*        )*/}
							{/*    }*/}
							{/*</button>*/}

							{/* WhatsApp Number - OTP Input | Verify OTP */}
							{/*{isSendPhoneNumberOtpSuccess && (!isVerifyPhoneNumberOtpSuccess) && (*/}
							{/*    <>*/}
							{/*        /!* WhatsApp Number - OTP Input *!/*/}
							{/*        <div className="custom-input-container">*/}
							{/*            <label htmlFor="phoneOtp">*/}
							{/*                {t("REGISTER_PAGE.OTP_BUTTON.ENTER")}*/}
							{/*            </label>*/}

							{/*            <input*/}
							{/*                type="text"*/}
							{/*                name="phoneOtp"*/}
							{/*                value={phoneNumberOtp}*/}
							{/*                onChange={(e) => setPhoneNumberOtp(e.target.value)}*/}
							{/*                id="otp"*/}
							{/*                className={`custom-input`}*/}
							{/*            />*/}
							{/*        </div>*/}

							{/*        /!* WhatsApp Number - Verify OTP *!/*/}
							{/*        <button*/}
							{/*            disabled={isVerifyPhoneNumberOtpButtonDisabled}*/}
							{/*            onClick={verifyPhoneNumberOtpButtonClick}*/}
							{/*            className={`${isVerifyPhoneNumberOtpButtonDisabled ? '' : 'arrow-button'} */}
							{/*                    w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]*/}
							{/*                    landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg*/}
							{/*                    */}
							{/*                    portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]*/}
							{/*                    landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]*/}
							{/*                    */}
							{/*                    hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 */}
							{/*                    disabled:cursor-not-allowed disabled:bg-slate-400/50 */}
							{/*                    disabled:ring-0 disabled:ring-offset-0*/}
							{/*                    transition-all duration-300 ease-in-out`}*/}
							{/*        >*/}
							{/*            <p*/}
							{/*                className="line-clamp-1 text-white leading-tight font-custom-medium*/}
							{/*                        portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
							{/*                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
							{/*                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"*/}
							{/*            >*/}
							{/*                {t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}*/}
							{/*            </p>*/}
							{/*            <svg*/}
							{/*                viewBox="0 0 6 6"*/}
							{/*                fill="none"*/}
							{/*                id={"arrow-icon"}*/}
							{/*                className="portrait:h-[1rem] portrait:md:h-[0.9rem]*/}
							{/*                        portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]*/}
							{/*                        landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]*/}
							{/*                        aspect-square"*/}
							{/*                xmlns="http://www.w3.org/2000/svg"*/}
							{/*            >*/}
							{/*                <path*/}
							{/*                    d="M3 1L5 3L3 5"*/}
							{/*                    id={"arrow-icon-tip"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*                <path*/}
							{/*                    d="M1 3L4 3"*/}
							{/*                    id={"arrow-icon-line"}*/}
							{/*                    stroke="white"*/}
							{/*                    strokeLinecap="square"*/}
							{/*                />*/}
							{/*            </svg>*/}
							{/*        </button>*/}
							{/*    </>*/}
							{/*)}*/}
						</div>

						{/* Footer */}
						<div
							className={`flex flex-col
                                portrait:gap-y-[1rem] portrait:jk:gap-y-[1.5rem] portrait:lg:gap-y-[2rem]
                                landscape:gap-y-[0.75rem] landscape:jk:gap-y-[0.9rem] landscape:lg:gap-y-[1.15rem]`}
						>
							{/* Divider | Previous | Next Buttons */}
							<div
								className={`flex flex-col justify-between
                                    portrait:px-[1.25rem] portrait:jk:px-[1.75rem] portrait:lg:px-[2.25rem]
                                    landscape:px-[0.75rem] landscape:jk:px-[0.9rem] landscape:lg:px-[1.15rem]
                                    
                                    portrait:gap-y-[1rem] portrait:jk:gap-y-[1.5rem] portrait:lg:gap-y-[2rem]
                                    landscape:gap-y-[0.75rem] landscape:jk:gap-y-[0.9rem] landscape:lg:gap-y-[0.75rem]`}
							>
								{/* Divider */}
								<div className={`h-[0.1rem] w-full bg-[#ECECEC] rounded-full`}/>

								{/* Previous | Next Buttons */}
								<div className={`flex justify-between`}>
									{/* Previous Step */}
									<button
										type="button"
										onClick={prevStep}
										disabled={currentStep === 1}
										className={`${currentStep !== 1 && 'left-arrow-button'}
                                            base-left-arrow-button flex items-center rounded-full
                                            transition-all duration-300 ease-in-out
                                            ${currentStep === 1
											? 'bg-gray-100 ring-0 ring-offset-0 cursor-not-allowed'
											: `bg-[#D26A53] hover:ring-offset-1 
                                                hover:ring-4 hover:ring-orange-300`}
                                        `}
									>
										<svg
											viewBox="0 0 6 6"
											fill="none"
											id="left-arrow-icon"
											className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                                portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                                portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                                landscape:h-[0.65rem] landscape:w-[0.65rem]
                                                landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                                landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M3 1L1 3L3 5"
												id="left-arrow-icon-tip"
												stroke={currentStep === 1 ? "#9ca3af" : "white"}
												strokeLinecap="square"
											/>
											<path
												d="M5 3L2 3"
												id="left-arrow-icon-line"
												stroke={currentStep === 1 ? "#9ca3af" : "white"}
												strokeLinecap="square"
											/>
										</svg>
										<p
											className={`font-custom-medium leading-tight line-clamp-1
                                                ${currentStep === 1 ? 'text-gray-400' : 'text-white'}
                                                portrait:text-[1rem] portrait:md:text-[1.25rem] portrait:jk:text-[1.15rem]
                                                landscape:text-[0.8rem] landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
										>
											{t("REGISTER_PAGE.PREVIOUS")}
										</p>
									</button>

									{/* Next Step | Create Account */}
									<button
										type="button"
										onClick={nextStep}
										disabled={areProfileDetailsValid[currentStep]}
										className={`${(!areProfileDetailsValid[currentStep] && 'arrow-button')}
                                            flex items-center base-right-arrow-button rounded-full
                                            bg-green-400 hover:bg-green-500 disabled:bg-green-700
                                            hover:ring-green-300 hover:ring-offset-1 hover:ring-4
                                            disabled:ring-0 disabled:ring-offset-0 disabled:cursor-not-allowed
                                            transition-all duration-300 ease-in-out`}
									>
										<p
											className={`font-custom-medium text-white leading-tight line-clamp-1
                                                portrait:text-[1rem] portrait:md:text-[1.25rem] portrait:jk:text-[1.15rem]
                                                landscape:text-[0.8rem] landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
										>
										</p>
										{
											(
												isMemberOfJoglekarKul2010Granth
													? currentStep === totalSteps
													: currentStep === totalSteps + 1
											)
												? t("REGISTER_PAGE.SUBMIT")
												: t("REGISTER_PAGE.NEXT")
										}
										<svg
											viewBox="0 0 6 6"
											fill="none"
											id={"arrow-icon"}
											className={`portrait:h-[0.85rem] portrait:w-[0.85rem]
                                                portrait:sm:h-[0.95rem] portrait:sm:w-[0.95rem]
                                                portrait:jk:h-[0.9rem] portrait:jk:w-[0.9rem]
                                                landscape:h-[0.65rem] landscape:w-[0.65rem]
                                                landscape:md:h-[0.75rem] landscape:md:w-[0.75rem]
                                                landscape:jk:h-[0.85rem] landscape:jk:w-[0.85rem]`}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M3 1L5 3L3 5"
												id={"arrow-icon-tip"}
												stroke="white"
												strokeLinecap="square"
											/>
											<path
												d="M1 3L4 3"
												id={"arrow-icon-line"}
												stroke="white"
												strokeLinecap="square"
											/>
										</svg>
									</button>
								</div>
							</div>

							{/* Create Account */}
							{/*<button*/}
							{/*    disabled={isRegisterButtonDisabled}*/}
							{/*    onClick={addNewAccount}*/}
							{/*    className={`${!(isRegisterButtonDisabled) && 'arrow-button'}*/}
							{/*        w-full flex flex-1 items-center justify-center */}
							{/*        gap-x-[0.5rem] bg-[#610329] hover:bg-[#000022] text-white*/}
							{/*        landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg*/}
							{/*        */}
							{/*        portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]*/}
							{/*        landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]*/}
							{/*        */}
							{/*        disabled:cursor-not-allowed disabled:bg-slate-400/50 */}
							{/*        disabled:ring-0 disabled:ring-offset-0*/}
							{/*        hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4*/}
							{/*        transition-all duration-300 ease-in-out`}*/}
							{/*>*/}
							{/*    <p*/}
							{/*        className="line-clamp-1 text-white leading-tight font-custom-medium*/}
							{/*                portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
							{/*                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
							{/*                landscape:text-[0.75rem] landscape:md:text-[0.8rem]*/}
							{/*                landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"*/}
							{/*    >*/}
							{/*        {t("REGISTER_PAGE.SUBMIT")}*/}
							{/*    </p>*/}
							{/*    <svg*/}
							{/*        viewBox="0 0 6 6"*/}
							{/*        fill="none"*/}
							{/*        id={"arrow-icon"}*/}
							{/*        className="portrait:h-[1rem] portrait:md:h-[0.9rem]*/}
							{/*            portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]*/}
							{/*            landscape:h-[0.7rem] landscape:md:h-[0.75rem]*/}
							{/*            landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]*/}
							{/*            aspect-square"*/}
							{/*        xmlns="http://www.w3.org/2000/svg"*/}
							{/*    >*/}
							{/*        <path*/}
							{/*            d="M3 1L5 3L3 5"*/}
							{/*            id={"arrow-icon-tip"}*/}
							{/*            stroke="white"*/}
							{/*            strokeLinecap="square"*/}
							{/*        />*/}
							{/*        <path*/}
							{/*            d="M1 3L4 3"*/}
							{/*            id={"arrow-icon-line"}*/}
							{/*            stroke="white"*/}
							{/*            strokeLinecap="square"*/}
							{/*        />*/}
							{/*    </svg>*/}
							{/*</button>*/}

							{/* Login */}
							<div
								className={`flex flex-1 flex-row items-center justify-center gap-[0.35rem]
                                    portrait:px-[1.25rem] portrait:jk:px-[1.75rem] portrait:lg:px-[2.25rem]
                                    landscape:px-[0.75rem] landscape:jk:px-[0.9rem] landscape:lg:px-[1.15rem]
                                    portrait:py-[0.5rem] portrait:jk:py-[0.75rem] portrait:lg:py-[1rem]
                                    landscape:py-[0.375rem] landscape:jk:py-[0.45rem] landscape:lg:py-[0.575rem]
                                    bg-[#610329] portrait:rounded-b-xl landscape:rounded-b-xl`}
							>
								<p
									className={`font-custom-medium leading-6 text-white
                                        portrait:text-[1rem] portrait:md:text-[0.8rem]
                                        portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                        landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                        landscape:jk:text-[0.75rem] landscape:lg:text-[0.95rem]`}
								>
									{t("REGISTER_PAGE.ALREADY_HAVE_ACCOUNT.P1")}
								</p>
								<Link
									to={'/login'}
									className={`font-custom-medium leading-6 text-white
                                        portrait:text-[1rem] portrait:md:text-[0.8rem]
                                        portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                        landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                        landscape:jk:text-[0.75rem] landscape:lg:text-[0.95rem]
                                        hover:underline transition duration-300 ease-in-out`}
								>
									{t("REGISTER_PAGE.ALREADY_HAVE_ACCOUNT.P2")}
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Navigate to Search Page Modal */}
			<>
				{document.body.classList.toggle("!overflow-y-hidden", showNavigateToSearchPageModal)}

				<Transition show={showNavigateToSearchPageModal}>
					<div
						className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh] 
                            min-w-[100dvw] w-[100dvw] max-w-[100dvw]
                            flex items-center justify-center 
                            fixed inset-0 z-[100]
                            bg-black/75 backdrop-blur-sm
                            data-[closed]:opacity-0
                            data-[enter]:duration-150 data-[enter]:data-[closed]:ease-out
                            data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
					>
						<TransitionChild
							enter="transition-transform duration-300 ease-out"
							enterFrom="translate-y-full"
							enterTo="translate-y-0"
							leave="transition-transform duration-300 ease-in"
							leaveFrom="translate-y-0"
							leaveTo="translate-y-full"
						>
							<div
								className="min-h-fit h-fit max-h-[30dvh]
                                    landscape:min-w-[25vw] landscape:max-w-[25vw]

                                    portrait:min-h-full portrait:h-full portrait:max-h-full
                                    portrait:md:!min-h-fit portrait:md:!h-fit portrait:md:!max-h-fit

                                    portrait:min-w-[100dvw] portrait:w-[100dvw] portrait:max-w-[100dvw]
                                    portrait:md:min-w-[40vw] portrait:md:max-w-[90vw]

                                    transform z-50 rounded-xl flex items-center justify-center
                                    data-[enter]:duration-150 data-[enter]:data-[closed]:scale-75
                                    data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95"
							>
								<div
									className="form-modal-container min-h-fit h-fit max-h-[60dvh]
                                        landscape:!min-w-[30vw] landscape:!w-[30vw] landscape:!max-w-[30vw]
                                        portrait:!min-w-[75vw] portrait:!w-[75vw] portrait:!max-w-[75vw]
                                        portrait:md:!min-w-[60dvw] portrait:md:!w-[60dvw] portrait:md:!max-w-[60dvw]"
								>
									{/* Header */}
									<div className={"form-modal-header-container"}>
										{/* Header Title | Close Button */}
										<div className={"flex flex-row items-center justify-between"}>
											{/* Form Title */}
											<h2>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.TITLE")}
											</h2>

											{/* Close Button */}
											<button onClick={() => setShowNavigateToSearchPageModal(false)}>
												<img
													className={"w-[75%] h-[75%]"}
													src={"/assets/close-icon.png"}
													alt={"Close"}
													title={"Close"}
												/>
											</button>
										</div>

										{/* Divider */}
										<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
									</div>

									{/* Content */}
									<div
										className={`form-modal-body-container
                                        !flex-1 !max-h-none !bg-transparent`}
									>
										{/* Description Steps */}
										<div
											className={`w-full flex-1 flex flex-col item-center
                                                portrait:gap-[1rem] portrait:md:gap-[0.6rem]
                                                portrait:jk:gap-[0.75rem] portrait:lg:gap-[0.85rem]
                                                landscape:gap-[0.4rem] landscape:md:gap-[0.45rem]
                                                landscape:jk:gap-[0.5rem] landscape:lg:gap-[0.75rem]`}
										>
											<p
												className={`text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight text-left`}
											>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.DESCRIPTION.P1")}
											</p>
											<p
												className={`text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight text-left`}
											>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.DESCRIPTION.P2")}
											</p>
											<p
												className={`text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight text-left`}
											>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.DESCRIPTION.P3")}
											</p>
											<p
												className={`text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight text-left`}
											>
												{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.DESCRIPTION.P4")}
											</p>
										</div>

										{/* Search Results Example Card */}
										<div
											className="w-full col-span-1
                                                min-h-[12.5vh] h-[12.5vh] max-h-[12.5vh]
                                                flex items-center gap-[1.5vh]
                                                p-[1.25vh] border-2 border-[#EAEAEA]
                                                rounded-2xl bg-white"
											style={{boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)"}}
										>
											{/* Profile Picture */}
											<div
												className={`shadow-xl z-10 rounded-xl h-full aspect-square
                                                    flex items-center justify-center bg-[#FF3C38]
                                                    border-2 border-white overflow-hidden`}
											>
												<img
													className="object-cover h-full drop-shadow-2xl aspect-square"
													src={"https://jogkulstorageuat.blob.core.windows.net/siteassets/myFolder/Anil-Photo_June2023.jpg"}
													alt="User Profile Image"
													referrerPolicy={"no-referrer"}
												/>
											</div>

											{/* Details */}
											<div
												className={`h-full flex-1 flex flex-col
                                                    items-start justify-between`}
											>
												{/* First Name | Middle Name */}
												<div
													className={`flex flex-col w-full items-start`}
												>
													<p
														className={`line-clamp-1 text-ellipsis overflow-scroll no-scrollbar
                                                            portrait:text-[1rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.725rem] landscape:md:text-[0.8rem]
                                                            landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]
                                                            leading-tight font-custom-bold text-[#3D3D3D]`}
													>
														{`${t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SEARCH_RESULT_EXAMPLE.FIRST_NAME")} ${t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SEARCH_RESULT_EXAMPLE.MIDDLE_NAME")}`}
													</p>
													<p
														className={`leading-tight font-custom-black text-[#3D3D3D]
                                                            portrait:text-[1rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.725rem] landscape:md:text-[0.8rem]
                                                            landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]`}
													>
														{`${t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SEARCH_RESULT_EXAMPLE.FIRST_NAME_DEVANAGARI")} ${t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SEARCH_RESULT_EXAMPLE.MIDDLE_NAME_DEVANAGARI")}`}
													</p>
												</div>

												{/* Family Tree Name */}
												<div
													className="h-fit max-w-full flex items-center justify-between
                                                        overflow-hidden bg-[#F3BC50] px-[1vw] py-[0.5vh]
                                                        rounded-full overflow-x-scroll no-scrollbar
                                                        text-nowrap line-clamp-1"
												>
													<p className={"text-ellipsis text-[1.35vh] font-custom-mono-bold text-[#3D3D3D]"}>
														{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SEARCH_RESULT_EXAMPLE.FAMILY_TREE_NAME")}
													</p>
												</div>
											</div>
										</div>
									</div>

									{/* Footer */}
									<div className={"form-modal-footer-container"}>
										{/* Divider */}
										<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

										{/* Submit Button Container */}
										<div className="flex items-center justify-end">
											{/* Submit Button */}
											<button
												onClick={() => window.open('/search', '_blank')}
												className="form-modal-footer-container-submit-button"
											>
												<p>
													{t("REGISTER_PAGE.EXACT_FAMILY_TREE_NAME.MODAL.SUBMIT")}
												</p>
												<svg
													viewBox="0 0 6 6"
													fill="none"
													id={"arrow-icon"}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M3 1L5 3L3 5"
														id={"arrow-icon-tip"}
														stroke="black"
														strokeLinecap="square"
													/>
													<path
														d="M1 3L4 3"
														id={"arrow-icon-line"}
														stroke="black"
														strokeLinecap="square"
													/>
												</svg>
											</button>
										</div>
									</div>
								</div>
							</div>
						</TransitionChild>
					</div>
				</Transition>
			</>

			{/* Matching Profiles Modal */}
			<Modal zIndex={"z-[100]"} isOpen={showMatchingProfilesModal}>
				<div
					className={`delete-modal-container`}
				>
					{/* Header */}
					<div className={"delete-modal-header-container"}>
						{/* Family Tree List Modal Header */}
						<div className={"flex flex-row items-center justify-between"}>
							{/* Modal Title */}
							<h2>
								{t("REGISTER_PAGE.MATCHING_PROFILES_MODAL.TITLE")}
							</h2>

							{/* Close Button */}
							<button
								onClick={() => setShowMatchingProfilesModal(false)}
							>
								<img
									className={"w-[75%] h-[75%]"}
									src={"/assets/close-icon.png"}
									alt={"Close"}
									title={"Close"}
								/>
							</button>
						</div>

						{/* Divider */}
						<div className={"h-[0.2vh] bg-[#ECECEC] rounded-full"}/>
					</div>

					{/* Matching Profiles List */}
					{
						matchingProfiles.length > 0
							? (
								<div
									className="delete-modal-body-container"
								>
									{
										matchingProfiles.map((data, index) => (
											<button
												className={`cursor-pointer
                                                    w-full flex-1 flex items-center gap-x-2 rounded-xl 
                                                    hover:shadow-lg px-[1vh] py-[1vh]
                                                    border-2 border-[#EAEAEA] bg-white
                                                    transition duration-150 ease-in-out`}
												key={index}
												// onClick={() => handleNodeClick(data.nodeId)}
											>
												{/* Profile Picture */}
												{data.imageUrl.length <= 2 ? (
													<div
														className={`z-10 w-[8vh] h-[8vh] overflow-hidden 
                                                            flex items-center justify-center rounded-lg 
                                                            shadow-xl border-2 border-[#F5F5F5] ${data.imageUrlBg}`}
													>
														<p
															className={
																"text-[1vw] text-white font-custom-mono-bold"
															}
														>
															{data.imageUrl.toUpperCase()}
														</p>
													</div>
												) : (
													<div
														className="z-10 w-[8vh] h-[8vh] overflow-hidden flex items-center justify-center rounded-lg bg-slate-500 border-2 border-white">
														<img
															src={
																!(data.imageUrl === "")
																	? data.imageUrl
																	: "/assets/default-pfp.png"
															}
															referrerPolicy={"no-referrer"}
															alt="Member Profile Picture"
														/>
													</div>
												)}

												{/* Firstname | Middlename | Family Tree Name */}
												<div
													className="h-full flex-1 flex flex-col items-start justify-between">
													<p className="text-[1.75vh] font-custom-medium text-[#3D3D3D] leading-snug">
														{data.firstName + " " + data.middleName}
													</p>
													<p className="text-[1.5vh] font-custom-medium text-[#3D3D3D] leading-snug">
														{data.firstNameDevanagariScript +
															" " +
															data.middleNameDevanagariScript}
													</p>
													<div className="py-[0.25vh] px-[0.5vw] bg-[#F3BC50] rounded-full">
														<p className="text-[1.25vh] font-custom-medium text-[#3D3D3D] leading-snug">
															{data.familyTreeName}
														</p>
													</div>
												</div>
											</button>
										))
									}
								</div>
							)
							: (
								<div
									className="delete-modal-body-container"
								>
									<p className={"text-[1.5vw] font-custom-mono-medium text-wrap text-center"}>
										{t(`REGISTER_PAGE.MATCHING_PROFILES_MODAL.NO_MATCHING_PROFILES`)}
									</p>
								</div>
							)
					}
				</div>
			</Modal>
		</>
	)
}
